(function () {
  var dashboards = document.querySelectorAll('[data-kpi-dashboard]');
  if (!dashboards.length) return;

  function escapeHtml(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function copyProps(from, to) {
    Object.keys(from || {}).forEach(function (k) { if (k !== 'ranges') to[k] = from[k]; });
    return to;
  }

  function clampPercent(v) {
    var n = parseFloat(v);
    return Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : 0;
  }

  function parseMetricNumber(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(/,/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  function formatInteger(v) {
    var n = parseMetricNumber(v);
    return Math.round(n).toLocaleString('en-US');
  }

  function toneClass(prefix, tone) {
    if (!tone || ['good', 'watch', 'bad', 'neutral'].indexOf(tone) === -1) return '';
    return ' ' + prefix + '--' + tone;
  }

  function getRanges(data) {
    return Array.isArray(data && data.ranges) ? data.ranges : null;
  }

  function rangeLabel(id) {
    if (id === '1d') return '1d'; if (id === '3d') return '3d';
    if (id === '7d') return '7d'; if (id === '14d') return '14d';
    if (id === 'custom') return 'Custom';
    return id || '';
  }

  function rangeControlLabel(id) {
    if (id === '1d') return '1d · last 24h';
    if (id === '3d') return '3d · last 72h';
    if (id === '7d') return '7d · last 7 days';
    if (id === '14d') return '14d · last 14 days';
    if (id === 'custom') return 'Custom dates';
    return rangeLabel(id);
  }

  function isLocalPreviewHost() {
    return location.hostname === '127.0.0.1' || location.hostname === 'localhost';
  }

  function canUseLocalBackendFromHost() {
    return isLocalPreviewHost();
  }

  function localBackendOrigin() {
    return location.protocol === 'https:' ? 'https://127.0.0.1:8766' : 'http://127.0.0.1:8765';
  }

  function normalizeLiveApiSource(source) {
    if (!source || !canUseLocalBackendFromHost() || source.indexOf('/apps/kpi-dashboard/api/') !== 0) return source;
    return localBackendOrigin() + '/api/' + source.split('/api/', 2)[1];
  }

  function normalizeSnapshotSource(source) {
    return source || '';
  }

  function localDateValue(date) {
    var copy = new Date(date.getTime());
    copy.setMinutes(copy.getMinutes() - copy.getTimezoneOffset());
    return copy.toISOString().slice(0, 10);
  }

  function defaultCustomRange() {
    var end = new Date();
    var start = new Date();
    start.setDate(start.getDate() - 3);
    return { from: localDateValue(start), to: localDateValue(end) };
  }

  function ensureCustomRange(data) {
    data.customRange = data.customRange || {};
    if (!data.customRange.from && !data.customRange.to) {
      data.customRange = defaultCustomRange();
      data.customRangeLabel = 'Custom: ' + data.customRange.from + ' – ' + data.customRange.to;
    }
    return data.customRange;
  }

  function findRange(data, id) {
    return (getRanges(data) || []).filter(function (r) { return r.id === id; })[0] || null;
  }

  function storageKey() {
    return 'mysheepi-kpi-dashboard-state:' + location.pathname;
  }

  function isReloadNavigation() {
    try {
      var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
      if (entries && entries[0]) return entries[0].type === 'reload';
    } catch (error) {}
    return !!(performance.navigation && performance.navigation.type === 1);
  }

  function clearInteractionState() {
    try { sessionStorage.removeItem(storageKey()); } catch (error) {}
    try { localStorage.removeItem(storageKey()); } catch (error) {}
  }

  function availableViewIds(root) {
    return Array.prototype.map.call(root.querySelectorAll('[data-kpi-view]'), function (el) {
      return el.getAttribute('data-kpi-view');
    }).filter(Boolean);
  }

  function validView(root, view) {
    var views = availableViewIds(root);
    return views.indexOf(view) !== -1 ? view : 'overview';
  }

  function validRange(range) {
    return ['1d', '3d', '7d', '14d', 'custom'].indexOf(String(range || '')) !== -1 ? String(range) : '';
  }

  function readSavedState(root) {
    if (!isReloadNavigation()) {
      clearInteractionState();
      return { view: 'overview', range: '', customRange: null };
    }
    try {
      var parsed = JSON.parse(sessionStorage.getItem(storageKey()) || '{}');
      return {
        view: validView(root, parsed.view || 'overview'),
        range: validRange(parsed.range),
        customRange: parsed.customRange && typeof parsed.customRange === 'object' ? parsed.customRange : null,
      };
    } catch (error) {
      return { view: 'overview', range: '', customRange: null };
    }
  }

  function saveDashboardState(root) {
    try {
      sessionStorage.setItem(storageKey(), JSON.stringify({
        view: validView(root, root.__pkpiView || 'overview'),
        range: validRange(root.__pkpiRangeId || root.__pkpiInitialRange || '1d') || '1d',
        customRange: root.__pkpiPendingCustomRange || root.__pkpiData && root.__pkpiData.customRange || null,
      }));
    } catch (error) {}
  }

  function fetchJson(url, options, timeoutMs, errorLabel) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, timeoutMs || 45000) : null;
    var requestOptions = options || {};
    if (controller) requestOptions.signal = controller.signal;
    return fetch(url, requestOptions)
      .then(function (response) {
        return response.text().then(function (text) {
          var payload = {};
          if (text) {
            try {
              payload = JSON.parse(text);
            } catch (parseError) {
              payload = { error: text.slice(0, 240) };
            }
          }
          if (!response.ok) {
            var message = payload && (payload.error || payload.message) || response.statusText || errorLabel || 'Live request failed';
            throw new Error(message);
          }
          return payload;
        });
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') {
          throw new Error((errorLabel || 'Live request') + ' timed out before real data came back.');
        }
        throw error;
      })
      .finally(function () {
        if (timer) window.clearTimeout(timer);
      });
  }

  function setCheckingStatus(root, message) {
    var status = root.querySelector('[data-kpi-feed-status]');
    if (status) {
      status.textContent = message || 'Checking for updates...';
      status.className = 'pkpi__hero-pill pkpi__hero-pill--status';
    }
  }

  function setActiveView(root, view) {
    root.__pkpiView = validView(root, view || 'overview');
    saveDashboardState(root);
  }

  function minimalDashboardData(root) {
    var ids = ['1d', '3d', '7d', '14d', 'custom'];
    var selected = validRange(root.__pkpiRangeId || root.__pkpiInitialRange) || '1d';
    return {
      availableRanges: ids.map(function (id) { return { id: id, label: rangeLabel(id) }; }),
      customRange: root.__pkpiPendingCustomRange || defaultCustomRange(),
      ranges: ids.map(function (id) {
        return { id: id, label: rangeLabel(id), rangeLabel: id === 'custom' ? 'Custom dates' : rangeControlLabel(id) };
      }),
      defaultRange: selected,
    };
  }

  function emptyRange(id, data) {
    var label = rangeLabel(id);
    var dailyLimit = data && data.feedStatus === 'daily-limit';
    var customLabel = data && data.customRangeLabel ? data.customRangeLabel : 'Custom period';
    var status = id === 'custom'
      ? 'No custom snapshot loaded yet'
      : 'No ' + label + ' snapshot loaded yet';
    if (dailyLimit && id !== 'custom') status += '; daily Clarity limit reached';
    return {
      id: id,
      label: label,
      rangeLabel: id === 'custom' ? customLabel : label + ' requested',
      statusLabel: status,
      rangeUnavailable: true,
      updatedAt: data && data.feedCheckedAt || '',
      checkedAt: data && data.feedCheckedAt || '',
      dataUpdatedAt: '',
      summary: [],
      charts: [],
      priorities: [],
      topPages: [],
      worstPages: [],
      funnel: [],
      pages: [],
      devices: [],
      sources: [],
      breakdowns: [],
      events: []
    };
  }

  function getSelectedData(data, rangeId) {
    var ranges = getRanges(data);
    var selected, view = {};
    if (ranges && ranges.length) {
      selected = ranges.filter(function (r) { return r.id === rangeId; })[0];
      if (!selected) {
        if (rangeId) {
          selected = emptyRange(rangeId, data);
        } else {
          selected = ranges.filter(function (r) { return r.id === data.defaultRange; })[0] || ranges[0];
        }
      }
      copyProps(data, view); copyProps(selected, view);
      view.id = selected.id; view.label = selected.label; view.ranges = ranges;
      return view;
    }
    copyProps(data, view); view.id = 'single'; return view;
  }

  function mergeRangeResponse(existing, incoming, rangeId) {
    if (!existing || !incoming || !Array.isArray(existing.ranges) || !Array.isArray(incoming.ranges)) return incoming;
    var incomingRange = findRange(incoming, rangeId) || incoming.ranges[0];
    if (!incomingRange) return incoming;
    var merged = Object.assign({}, existing, incoming);
    merged.defaultRange = existing.defaultRange || incoming.defaultRange;
    merged.availableRanges = incoming.availableRanges || existing.availableRanges;
    var replaced = false;
    merged.ranges = existing.ranges.map(function (range) {
      if (range.id === incomingRange.id) {
        replaced = true;
        return incomingRange;
      }
      return range;
    });
    if (!replaced) merged.ranges.push(incomingRange);
    return merged;
  }

  function emptyMsg(msg, colspan) {
    if (colspan) return '<tr><td colspan="' + colspan + '" class="pkpi__empty">' + escapeHtml(msg) + '</td></tr>';
    return '<p class="pkpi__empty">' + escapeHtml(msg) + '</p>';
  }

  // ── Sparkline ──────────────────────────────────────────────────────────────

  function sparklineSvg(values, tone) {
    if (!Array.isArray(values) || values.length < 2) return '';
    var nums = values.map(Number).filter(isFinite);
    if (nums.length < 2) return '';
    var min = Math.min.apply(null, nums), max = Math.max.apply(null, nums);
    var range = max - min || 1, W = 56, H = 28, p = 3;
    var step = (W - p * 2) / (nums.length - 1);
    var color = tone === 'good' ? '#6f812b' : tone === 'bad' ? '#b83232' : '#7d6b1e';
    var d = nums.map(function (v, i) {
      var x = (p + i * step).toFixed(1);
      var y = (p + (H - p * 2) - ((v - min) / range) * (H - p * 2)).toFixed(1);
      return (i === 0 ? 'M' : 'L') + x + ',' + y;
    }).join(' ');
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" class="pkpi__spark" aria-hidden="true" preserveAspectRatio="none">' +
      '<path d="' + d + '" stroke="' + color + '" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  // ── Controls: period selector (hero right slot) ────────────────────────────

  function renderPeriodSlot(root, data, selectedId) {
    var target = root.querySelector('[data-kpi-period-slot]');
    if (!target) return;
    var ranges = getRanges(data);
    if (!ranges || !ranges.length) { target.innerHTML = ''; return; }
    var configuredRanges = Array.isArray(data.availableRanges) && data.availableRanges.length
      ? data.availableRanges.map(function (r) { return r.id; })
      : ['1d', '3d', '7d', '14d', 'custom'];
    var fixedRanges = configuredRanges.filter(function (id) {
      return id === '1d' || id === '3d' || id === '7d' || id === '14d' || id === 'custom';
    });
    var custom = selectedId === 'custom' ? ensureCustomRange(data) : (data.customRange || {});
    target.innerHTML = [
      '<div class="pkpi__hero-period">',
      '<span class="pkpi__period-label">Time period</span>',
      '<select data-kpi-range-select aria-label="Time period">',
      fixedRanges.map(function (id) {
        var range = findRange(data, id);
        var sel = id === selectedId ? ' selected' : '';
        var unavailable = range && range.rangeUnavailable && id !== selectedId && id !== 'custom' && !data.shopifyAvailable;
        var disabled = unavailable ? ' disabled' : '';
        var lbl = rangeControlLabel(id);
        if (unavailable) lbl += ' unavailable';
        return '<option value="' + escapeHtml(id) + '"' + sel + disabled + '>' + escapeHtml(lbl) + '</option>';
      }).join(''),
      '</select>',
      '<div class="pkpi__hero-period-custom" data-kpi-custom-period' + (selectedId === 'custom' ? '' : ' hidden') + '>',
      '<label><span>From</span><input type="date" data-kpi-custom-from value="' + escapeHtml(custom.from || '') + '"></label>',
      '<label><span>To</span><input type="date" data-kpi-custom-to value="' + escapeHtml(custom.to || '') + '"></label>',
      '<button type="button" data-kpi-apply-custom>Apply</button>',
      '</div>',
      '</div>',
    ].join('');

    var sel = target.querySelector('[data-kpi-range-select]');
    if (sel) sel.addEventListener('change', function () {
      var next = sel.value || '1d';
      if (next === 'custom') {
        var form = target.querySelector('[data-kpi-custom-period]');
        if (form) form.hidden = false;
        var customRange = ensureCustomRange(root.__pkpiData || data);
        root.__pkpiInitialRange = 'custom';
        root.__pkpiPendingCustomRange = customRange;
        saveDashboardState(root);
        var from = target.querySelector('[data-kpi-custom-from]');
        var to = target.querySelector('[data-kpi-custom-to]');
        if (from) from.value = customRange.from || '';
        if (to) to.value = customRange.to || '';
        return;
      }
      if (typeof root.__pkpiFetchAndRender === 'function') {
        root.__pkpiInitialRange = next;
        saveDashboardState(root);
        var cachedRange = findRange(root.__pkpiData, next);
        if (cachedRange && cachedRange.shopify) {
          renderDashboard(root, root.__pkpiData, next);
          setCheckingStatus(root, 'Showing saved values; checking for updates...');
          root.__pkpiFetchAndRender(next, false, { quiet: true });
        } else {
          root.__pkpiFetchAndRender(next, true);
        }
      } else {
        renderDashboard(root, root.__pkpiData, next);
        runSpeedAudit(root, false);
      }
    });

    var applyBtn = target.querySelector('[data-kpi-apply-custom]');
    if (applyBtn) applyBtn.addEventListener('click', function () {
      var from = target.querySelector('[data-kpi-custom-from]');
      var to = target.querySelector('[data-kpi-custom-to]');
      var targetData = root.__pkpiData || data;
      targetData.customRange = { from: from && from.value || '', to: to && to.value || '' };
      targetData.customRangeLabel = (from && from.value && to && to.value)
        ? 'Custom: ' + from.value + ' – ' + to.value : 'Custom period';
      root.__pkpiInitialRange = 'custom';
      root.__pkpiPendingCustomRange = targetData.customRange;
      saveDashboardState(root);
      if (typeof root.__pkpiFetchAndRender === 'function') {
        root.__pkpiFetchAndRender('custom', true);
      } else {
        renderDashboard(root, root.__pkpiData, 'custom');
        runSpeedAudit(root, false);
      }
    });
  }

  // ── Controls: nav tabs bar ─────────────────────────────────────────────────

  function bindNavigationShell(root) {
    if (root.__pkpiNavigationBound) return;
    root.__pkpiNavigationBound = true;
    if (!root.__pkpiSiteEvidenceResizeBound) {
      root.__pkpiSiteEvidenceResizeBound = true;
      window.addEventListener('resize', function () {
        scheduleSiteEvidenceHeightSync(root);
      });
    }
    var home = root.querySelector('[data-kpi-home]');
    if (home) {
      home.addEventListener('click', function () {
        setActiveView(root, 'overview');
        applyView(root);
        renderControls(root, root.__pkpiData, root.__pkpiRangeId);
      });
    }
  }

  function refreshActivatedView(root, viewId) {
    if (!root.__pkpiData) return;
    if (viewId === 'pages') {
      renderPages(root, getSelectedData(root.__pkpiData, root.__pkpiRangeId).pages);
    } else if (viewId === 'overview') {
      renderCurrentHealth(root);
    } else if (viewId === 'site') {
      scheduleSiteEvidenceHeightSync(root);
    }
  }

  function renderControls(root, data, selectedId) {
    bindNavigationShell(root);
    var targets = Array.prototype.slice.call(root.querySelectorAll('[data-kpi-controls]'));
    if (!targets.length) return;
    var activeView = root.__pkpiView || 'overview';
    var views = [
      { id: 'overview', label: 'Overview' },
      { id: 'pages', label: 'Pages' },
      { id: 'traffic', label: 'Traffic' },
      { id: 'events', label: 'Events' },
      { id: 'glossary', label: 'Glossary' },
    ];
    if (root.querySelector('[data-kpi-view="site"]')) {
      views.splice(1, 0, { id: 'site', label: 'Site Check' });
    }
    if (root.querySelector('[data-kpi-view="speed"]')) {
      views.splice(1, 0, { id: 'speed', label: 'Speed' });
    }
    targets.forEach(function (target) {
      target.innerHTML = '<div class="pkpi__tabs-inner">' +
        views.map(function (v) {
          var active = v.id === activeView ? ' pkpi__tab--active' : '';
          return '<button type="button" class="pkpi__tab' + active + '" data-kpi-view-button="' + v.id + '">' + v.label + '</button>';
        }).join('') +
        '</div>';

      Array.prototype.forEach.call(target.querySelectorAll('[data-kpi-view-button]'), function (btn) {
        btn.addEventListener('click', function () {
          setActiveView(root, btn.getAttribute('data-kpi-view-button') || 'overview');
          applyView(root);
          refreshActivatedView(root, root.__pkpiView);
          renderControls(root, root.__pkpiData, root.__pkpiRangeId);
        });
      });
    });

    // Also bind the search in the pages view content area
    var search = root.querySelector('[data-kpi-search]');
    if (search && !search.dataset.kpiSearchBound) {
      search.dataset.kpiSearchBound = '1';
      search.value = root.__pkpiSearch || '';
      search.addEventListener('input', function () {
        root.__pkpiSearch = search.value;
        root.__pkpiPageNumber = 1;
        renderPages(root, getSelectedData(root.__pkpiData, root.__pkpiRangeId).pages);
      });
    }
  }

  // ── View switching ─────────────────────────────────────────────────────────

  function applyView(root) {
    var active = root.__pkpiView || 'overview';
    Array.prototype.forEach.call(root.querySelectorAll('[data-kpi-view]'), function (el) {
      el.hidden = el.getAttribute('data-kpi-view') !== active;
    });
    if (active === 'site') scheduleSiteEvidenceHeightSync(root);
  }

  // ── Meta pills ─────────────────────────────────────────────────────────────

  function renderMeta(root, data) {
    var updated = root.querySelector('[data-kpi-updated]');
    var range = root.querySelector('[data-kpi-range]');
    var status = root.querySelector('[data-kpi-feed-status]');
    if (updated) {
      var snapshotAt = data.dataUpdatedAt || data.updatedAt || '';
      if (data.checkedAt && snapshotAt && data.checkedAt !== snapshotAt) {
        updated.textContent = 'Checked ' + data.checkedAt + ' · snapshot ' + snapshotAt;
      } else {
        updated.textContent = data.updatedAt ? 'Updated ' + data.updatedAt : data.checkedAt ? 'Checked ' + data.checkedAt : '';
      }
    }
    if (range) range.textContent = data.rangeLabel || '';
    if (status) {
      status.textContent = data.statusLabel || 'Connected';
      status.className = 'pkpi__hero-pill pkpi__hero-pill--live';
    }
  }

  // ── Stat strip ─────────────────────────────────────────────────────────────

  function renderSummary(root, items) {
    var target = root.querySelector('[data-kpi-summary]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) {
      target.innerHTML = emptyMsg(root.__pkpiRangeUnavailable ? 'No snapshot loaded for this period.' : 'No summary data yet.'); return;
    }
    var limit = parseInt(target.getAttribute('data-kpi-limit') || '', 10);
    var visible = Number.isFinite(limit) && limit > 0 ? items.slice(0, limit) : items;
    target.innerHTML = visible.map(function (item) {
      var spark = sparklineSvg(item.sparkline, item.tone);
      var tone = item.tone || '';
      var toneMod = tone ? ' pkpi__stat--' + tone : '';
      var deltaClass = tone ? ' pkpi__stat-delta--' + tone : '';
      return '<div class="pkpi__stat' + toneMod + '">' +
        '<div class="pkpi__stat-top">' +
        '<span class="pkpi__stat-label">' + escapeHtml(item.label) + '</span>' + spark +
        '</div>' +
        '<strong class="pkpi__stat-value">' + escapeHtml(item.value) + '</strong>' +
        (item.delta ? '<span class="pkpi__stat-delta' + deltaClass + '">' + escapeHtml(item.delta) + '</span>' : '') +
        (item.detail ? '<span class="pkpi__stat-note">' + escapeHtml(item.detail) + '</span>' : '') +
        '</div>';
    }).join('');
  }

  function buildSummaryItems(view) {
    var HIDE_LABELS = ['users', 'top page', 'friction page', 'purchase data', 'bot sessions', 'orders', 'sales', 'aov'];
    var items = (Array.isArray(view.summary) ? view.summary : [])
      .filter(function (s) { return HIDE_LABELS.indexOf((s.label || '').toLowerCase()) === -1; })
      .map(function (item) {
        var copy = {};
        Object.keys(item || {}).forEach(function (key) { copy[key] = item[key]; });
        if ((copy.label || '').toLowerCase() === 'sessions') {
          var source = String(copy.delta || '').toLowerCase();
          if (source.indexOf('shopify') === -1) {
            copy.label = 'Clarity sessions';
            copy.delta = 'Behavior feed';
            copy.detail = 'Clarity behavior sessions only; Shopify Analytics is the source for storewide sessions when reports access is available.';
          }
        }
        return copy;
      });

    if (Array.isArray(view.pages) && view.pages.length) {
      var pageCount = {
        label: 'Tracked pages',
        value: formatInteger(view.pages.length),
        delta: 'Grouped URLs',
        tone: 'neutral',
        detail: 'Canonical pages with Clarity data in this period.',
      };
      var sessionIndex = items.findIndex(function (item) {
        return (item.label || '').toLowerCase() === 'sessions';
      });
      items.splice(sessionIndex >= 0 ? sessionIndex + 1 : 1, 0, pageCount);
    }

    return items;
  }

  // ── Bar charts ─────────────────────────────────────────────────────────────

  function renderCharts(root, selectorOrItems, altItems) {
    var selector = typeof selectorOrItems === 'string' ? selectorOrItems : '[data-kpi-charts]';
    var items = typeof selectorOrItems === 'string' ? altItems : selectorOrItems;
    var target = root.querySelector(selector);
    if (!target) return;
    if (!Array.isArray(items) || !items.length) {
      target.innerHTML = emptyMsg('No chart data yet — connect the Clarity feed.'); return;
    }
    target.innerHTML = items.map(function (chart) {
      var rows = Array.isArray(chart.items) ? chart.items : [];
      var values = rows.map(function (row) { return parseMetricNumber(row.value); });
      var max = Math.max.apply(null, values) || 0;
      var logMax = max > 0 ? Math.log(max + 1) : 0;
      return '<div class="pkpi__chart-card">' +
        '<span class="pkpi__chart-eyebrow">' + escapeHtml(chart.label || '') + '</span>' +
        '<h3 class="pkpi__chart-title">' + escapeHtml(chart.title || '') + '</h3>' +
        '<div class="pkpi__chart-rows">' +
        rows.map(function (row, i) {
          var rawPct = clampPercent(row.percent);
          var scaledPct = logMax ? Math.round((Math.log(values[i] + 1) / logMax) * 100) : rawPct;
          var pct = values[i] > 0 ? Math.max(3, scaledPct) : rawPct;
          var fillClass = row.tone ? ' pkpi__chart-fill--' + row.tone : '';
          return '<div class="pkpi__chart-row">' +
            '<span class="pkpi__chart-row-label" title="' + escapeHtml(row.label) + '">' + escapeHtml(row.label) + '</span>' +
            '<div class="pkpi__chart-track"><div class="pkpi__chart-fill' + fillClass + '" style="--pkpi-chart-width:' + pct + '%;width:' + pct + '%"></div></div>' +
            '<span class="pkpi__chart-row-value">' + escapeHtml(row.value) + '</span>' +
            '</div>';
        }).join('') +
        '</div></div>';
    }).join('');
  }

  // ── Issues ─────────────────────────────────────────────────────────────────

  function renderPriorities(root, items) {
    var target = root.querySelector('[data-kpi-priorities]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) {
      target.innerHTML = emptyMsg('No issues found yet.'); return;
    }
    target.innerHTML = '<div class="pkpi__issue-grid">' +
      items.map(function (item, i) {
        var tone = item.tone || 'watch';
        var page = item.page || item.path || '';
        var metric = item.metric || item.value || '';
        var action = item.action || (Array.isArray(item.actions) && item.actions[0]) || '';
        return '<div class="pkpi__issue-card">' +
          '<div class="pkpi__issue-card-top">' +
          '<span class="pkpi__issue-rank pkpi__issue-rank--' + tone + '">' + escapeHtml(String(item.rank || i + 1)) + '</span>' +
          '<span class="pkpi__issue-title">' + escapeHtml(item.title || '') + '</span>' +
          '</div>' +
          (page ? '<div class="pkpi__issue-page">' + escapeHtml(page) + '</div>' : '') +
          (metric ? '<div class="pkpi__issue-metric pkpi__issue-metric--' + tone + '">' + escapeHtml(metric) + '</div>' : '') +
          (action ? '<div class="pkpi__issue-row2">→ ' + escapeHtml(action) + '</div>' : '') +
          '</div>';
      }).join('') +
      '</div>';
  }

  // ── Derive topPages / worstPages from raw pages data ───────────────────────

  function deriveTopPages(pages) {
    if (!Array.isArray(pages) || !pages.length) return [];
    return pages.slice()
      .sort(function (a, b) { return parseMetricNumber(pagePeriodMetric(b, 'views')) - parseMetricNumber(pagePeriodMetric(a, 'views')); })
      .slice(0, 6)
      .map(function (p) {
        var label = p.issue && p.issue !== 'Clarity URL' && p.issue !== 'Imported from Microsoft Clarity URL dimension' ? p.issue : '';
        var visitors = pagePeriodMetric(p, 'views');
        return {
          path: p.path,
          label: label,
          metric: visitors === '-' ? 'Shopify visitors unavailable' : visitors + ' Shopify visitors',
          tone: 'good',
          sub: p.engagedTime && p.engagedTime !== '-' ? p.engagedTime + ' avg engaged' : ''
        };
      });
  }

  function deriveWorstPages(pages) {
    if (!Array.isArray(pages) || !pages.length) return [];
    var sorted = pages.slice()
      .filter(function (p) { return parseInt(p.quickBacks || 0) > 0; })
      .sort(function (a, b) { return parseInt(b.quickBacks || 0) - parseInt(a.quickBacks || 0); })
      .slice(0, 6);
    if (!sorted.length) {
      sorted = pages.slice()
        .sort(function (a, b) { return parseInt(b.rageClicks || 0) - parseInt(a.rageClicks || 0); })
        .filter(function (p) { return parseInt(p.rageClicks || 0) > 0; })
        .slice(0, 6);
    }
    return sorted.map(function (p) {
      var subs = [];
      if (parseInt(p.rageClicks || 0) > 0) subs.push(p.rageClicks + ' rage');
      if (p.scrollDepth && p.scrollDepth !== '-') subs.push(p.scrollDepth + ' scroll');
      return {
        path: p.path,
        label: p.issue && p.issue !== 'Clarity URL' ? p.issue : '',
        metric: p.quickBacks > 0 ? p.quickBacks + ' quick backs' : p.rageClicks + ' rage clicks',
        tone: 'bad',
        sub: subs.join(' · ')
      };
    });
  }

  // ── Column chart (full-width overview) ─────────────────────────────────────

  function renderOverviewChart(root, charts) {
    var target = root.querySelector('[data-kpi-overview-chart]');
    if (!target) return;
    if (!Array.isArray(charts) || !charts.length) { target.innerHTML = ''; return; }
    var chart = charts[0];
    var items = (chart.items || []).slice(0, 10);
    if (!items.length) { target.innerHTML = ''; return; }

    var values = items.map(function (it) { return parseMetricNumber(it.value); });
    var max = Math.max.apply(null, values) || 1;
    // Log scale so small bars are still visible
    var logMax = Math.log(max + 1);
    function scale(v) { return Math.log(v + 1) / logMax; }

    var bars = items.map(function (item, i) {
      var val = values[i];
      var rawLabel = item.label || '';
      var slug = String(rawLabel).replace(/^https?:\/\//, '').replace(/^www\.[^/]+/, '');
      var parts = slug.split('/').filter(Boolean);
      var display = parts.length ? parts[parts.length - 1].replace(/-/g, ' ').slice(0, 32) : '/';
      var barHeight = val > 0 ? Math.max(7, Math.round(scale(val) * 100)) : 0;
      var tone = item.tone && ['good', 'watch', 'bad'].indexOf(item.tone) !== -1 ? item.tone : 'good';
      var zeroClass = val > 0 ? '' : ' pkpi__col-bar--zero';
      var valueLabel = item.value == null || item.value === '' ? String(Math.round(val)) : String(item.value);
      var aria = display + ': ' + valueLabel;

      return '<div class="pkpi__col-bar pkpi__col-bar--' + tone + zeroClass + '" aria-label="' + escapeHtml(aria) + '" title="' + escapeHtml(rawLabel) + '">' +
        '<span class="pkpi__col-bar-value">' + escapeHtml(valueLabel) + '</span>' +
        '<span class="pkpi__col-bar-track" aria-hidden="true">' +
        '<span class="pkpi__col-bar-fill" style="--pkpi-bar:' + barHeight + '%"></span>' +
        '</span>' +
        '<span class="pkpi__col-bar-label">' + escapeHtml(display) + '</span>' +
        '</div>';
    }).join('');

    target.innerHTML =
      '<div class="pkpi__col-chart-card">' +
      '<div class="pkpi__col-chart-header">' +
      '<div>' +
      '<span class="pkpi__chart-eyebrow">' + escapeHtml(chart.label || 'Traffic') + '</span>' +
      '<h3 class="pkpi__col-chart-title">' + escapeHtml(chart.title || '') + '</h3>' +
      '</div>' +
      (chart.note ? '<p class="pkpi__col-chart-note">' + escapeHtml(chart.note) + '</p>' : '') +
      '</div>' +
      '<div class="pkpi__col-chart-scroll">' +
      '<div class="pkpi__col-chart-plot" role="img" aria-label="' + escapeHtml(chart.title || '') + '">' +
      '<div class="pkpi__col-chart-grid" aria-hidden="true"></div>' +
      '<div class="pkpi__col-chart-bars" style="--pkpi-chart-items:' + items.length + ';">' +
      bars +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';
  }

  // ── Top pages ──────────────────────────────────────────────────────────────

  function renderPageList(target, items, defaultTone) {
    if (!Array.isArray(items) || !items.length) { target.innerHTML = emptyMsg('No rows in this snapshot.'); return; }
    target.innerHTML = items.map(function (item) {
      var tone = item.tone || defaultTone || 'good';
      return '<div class="pkpi__page-row">' +
        '<div><span class="pkpi__page-path">' + escapeHtml(item.path || '') + '</span>' +
        (item.label ? '<span class="pkpi__page-type">' + escapeHtml(item.label) + '</span>' : '') + '</div>' +
        '<div><span class="pkpi__page-metric pkpi__page-metric--' + tone + '">' + escapeHtml(item.metric || '') + '</span>' +
        (item.sub ? '<span class="pkpi__page-sub">' + escapeHtml(item.sub) + '</span>' : '') + '</div>' +
        '</div>';
    }).join('');
  }

  function renderTopPages(root, items) {
    var target = root.querySelector('[data-kpi-top-pages]');
    if (!target) return;
    renderPageList(target, items, 'good');
  }

  // ── Worst pages ────────────────────────────────────────────────────────────

  function renderWorstPages(root, items) {
    var target = root.querySelector('[data-kpi-worst-pages]');
    if (!target) return;
    renderPageList(target, items, 'bad');
  }

  // ── Funnel ─────────────────────────────────────────────────────────────────

  function renderFunnel(root, items) {
    var target = root.querySelector('[data-kpi-funnel]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) { target.innerHTML = emptyMsg('No funnel data.'); return; }
    target.innerHTML = '<div class="pkpi__funnel-card">' +
      items.map(function (item) {
        var pct = clampPercent(item.percent);
        return '<div class="pkpi__step">' +
          '<span class="pkpi__step-label">' + escapeHtml(item.label) + '</span>' +
          '<span class="pkpi__track"><span class="pkpi__bar' + toneClass('pkpi__bar', item.tone) + '" style="--pkpi-value:' + pct + '%"></span></span>' +
          '<span class="pkpi__step-value">' + escapeHtml(item.value) + '</span>' +
          (item.note ? '<span class="pkpi__step-note">' + escapeHtml(item.note) + '</span>' : '') +
          '</div>';
      }).join('') + '</div>';
  }

  // ── All pages table ────────────────────────────────────────────────────────

  function decodeLoose(value) {
    try { return decodeURIComponent(String(value || '').replace(/\+/g, ' ')); }
    catch (e) { return String(value || ''); }
  }

  function normalizeSearchText(value) {
    var text = decodeLoose(value).toLowerCase().trim();
    text = text.replace(/^https?:\/\//, '').replace(/^www\./, '');
    text = text.replace(/[?#].*$/, '');
    text = text.replace(/\.html?\b/g, '');
    text = text.replace(/\/index\b/g, '/');
    text = text.replace(/[-_]+/g, ' ');
    text = text.replace(/[^a-z0-9/]+/g, ' ');
    text = text.replace(/\/+/g, '/');
    return text.replace(/\s+/g, ' ').trim();
  }

  function pageSearchHaystack(item) {
    var path = String(item && item.path || '');
    var variants = [
      path,
      path.charAt(0) === '/' ? 'mysheepi.com' + path : path,
      path.charAt(0) === '/' ? 'www.mysheepi.com' + path : path,
      path.charAt(0) === '/' ? 'https://mysheepi.com' + path : path,
      item && item.issue,
      item && item.recommendation
    ];
    return variants.concat(variants.map(normalizeSearchText)).join(' ').toLowerCase();
  }

  function pageMatchesQuery(item, query) {
    var raw = String(query || '').toLowerCase().trim();
    if (!raw) return true;
    var normalized = normalizeSearchText(raw);
    var haystack = pageSearchHaystack(item);
    if (haystack.indexOf(raw) !== -1 || haystack.indexOf(normalized) !== -1) return true;
    var tokens = normalized.split(/\s+/).filter(function (token) { return token.length > 1; });
    return tokens.length ? tokens.every(function (token) { return haystack.indexOf(token) !== -1; }) : false;
  }

  function hasBehaviorSignal(item) {
    if (!item) return false;
    return secondsFromText(item.engagedTime) > 0 ||
      parseMetricNumber(item.scrollDepth) > 0 ||
      parseMetricNumber(item.quickBacks) > 0 ||
      parseMetricNumber(item.rageClicks) > 0 ||
      parseMetricNumber(item.deadClicks) > 0 ||
      parseMetricNumber(item.excessiveScroll) > 0 ||
      parseMetricNumber(item.scriptErrors) > 0 ||
      parseMetricNumber(item.errorClicks) > 0;
  }

  function firstKnownMetric() {
    for (var i = 0; i < arguments.length; i++) {
      var value = arguments[i];
      if (value == null) continue;
      var text = String(value).trim();
      if (text && text !== '-') return value;
    }
    return '-';
  }

  function pagePeriodMetric(item, key) {
    if (!item) return '-';
    var raw = firstKnownMetric(item.shopifyVisitors);
    var hasShopifyTraffic = raw !== '-';
    if (!hasShopifyTraffic) raw = '-';
    var knownFlag = item.trafficKnown;
    if (knownFlag === false && !hasShopifyTraffic) return '-';
    if (raw == null || String(raw).trim() === '' || String(raw).trim() === '-') return '-';
    if (parseMetricNumber(raw) === 0 && hasBehaviorSignal(item) && !hasShopifyTraffic) {
      return '-';
    }
    return raw;
  }

  function pageSortState(root) {
    if (!root.__pkpiPageSort) root.__pkpiPageSort = { key: 'views', dir: 'desc' };
    return root.__pkpiPageSort;
  }

  function secondsFromText(value) {
    var text = String(value || '').toLowerCase().trim();
    if (!text || text === '-') return 0;
    if (text.indexOf(':') !== -1) {
      return text.split(':').reduce(function (total, part) {
        var n = parseFloat(part);
        return Number.isFinite(n) ? total * 60 + n : total;
      }, 0);
    }
    var total = 0;
    text.replace(/(\d+(?:\.\d+)?)\s*(h|m|s)/g, function (_, number, unit) {
      var value = parseFloat(number);
      if (!Number.isFinite(value)) return '';
      if (unit === 'h') total += value * 3600;
      if (unit === 'm') total += value * 60;
      if (unit === 's') total += value;
      return '';
    });
    return total || parseMetricNumber(text);
  }

  function pageSortValue(item, key) {
    if (key === 'name') return normalizeSearchText(item && item.path || '');
    if (key === 'engaged') return secondsFromText(item && item.engagedTime);
    if (key === 'scroll') return parseMetricNumber(item && item.scrollDepth);
    if (key === 'quickBacks') return parseMetricNumber(item && item.quickBacks);
    if (key === 'rageClicks') return parseMetricNumber(item && item.rageClicks);
    if (key === 'deadClicks') return parseMetricNumber(item && item.deadClicks);
    return parseMetricNumber(pagePeriodMetric(item, 'views'));
  }

  function pageSortMissing(item, key) {
    if (key === 'name') return !normalizeSearchText(item && item.path || '');
    var value = key === 'engaged' ? item && item.engagedTime
      : key === 'scroll' ? item && item.scrollDepth
        : key === 'quickBacks' ? item && item.quickBacks
          : key === 'rageClicks' ? item && item.rageClicks
            : key === 'deadClicks' ? item && item.deadClicks
              : pagePeriodMetric(item, 'views');
    return value == null || String(value).trim() === '' || String(value).trim() === '-';
  }

  function sortPages(items, sort) {
    return items.slice().sort(function (a, b) {
      var am = pageSortMissing(a, sort.key);
      var bm = pageSortMissing(b, sort.key);
      if (am !== bm) return am ? 1 : -1;
      var av = pageSortValue(a, sort.key);
      var bv = pageSortValue(b, sort.key);
      var result;
      if (typeof av === 'string' || typeof bv === 'string') {
        result = String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });
      } else {
        result = av - bv;
      }
      if (result === 0) {
        result = normalizeSearchText(a && a.path || '').localeCompare(normalizeSearchText(b && b.path || ''), undefined, { numeric: true, sensitivity: 'base' });
      }
      return sort.dir === 'asc' ? result : -result;
    });
  }

  function defaultPageSortDir(key) {
    return key === 'name' ? 'asc' : 'desc';
  }

  function setPageSort(root, key, dir) {
    var current = pageSortState(root);
    var nextDir = dir || (current.key === key ? (current.dir === 'desc' ? 'asc' : 'desc') : defaultPageSortDir(key));
    root.__pkpiPageSort = { key: key, dir: nextDir };
    root.__pkpiPageNumber = 1;
    renderPages(root, getSelectedData(root.__pkpiData, root.__pkpiRangeId).pages);
  }

  function renderPageSortControls(root) {
    var sort = pageSortState(root);
    var select = root.querySelector('[data-kpi-page-sort-select]');
    var dirButton = root.querySelector('[data-kpi-page-sort-dir]');
    if (select) {
      select.value = sort.key;
      if (!select.dataset.kpiSortBound) {
        select.dataset.kpiSortBound = '1';
        select.addEventListener('change', function () {
          setPageSort(root, select.value || 'views');
        });
      }
    }
    if (dirButton) {
      dirButton.textContent = sort.dir === 'asc' ? 'Asc' : 'Desc';
      dirButton.setAttribute('aria-label', 'Sort ' + (sort.dir === 'asc' ? 'ascending' : 'descending'));
      if (!dirButton.dataset.kpiSortBound) {
        dirButton.dataset.kpiSortBound = '1';
        dirButton.addEventListener('click', function () {
          var current = pageSortState(root);
          setPageSort(root, current.key, current.dir === 'asc' ? 'desc' : 'asc');
        });
      }
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-kpi-page-sort]'), function (button) {
      var key = button.getAttribute('data-kpi-page-sort') || 'views';
      var active = key === sort.key;
      var th = button.closest('th');
      if (th) th.setAttribute('aria-sort', active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none');
      button.classList.toggle('pkpi__sort-button--active', active);
      button.setAttribute('data-kpi-sort-dir', active ? sort.dir : 'none');
      if (!button.dataset.kpiSortBound) {
        button.dataset.kpiSortBound = '1';
        button.addEventListener('click', function () {
          setPageSort(root, button.getAttribute('data-kpi-page-sort') || 'views');
        });
      }
    });
  }

  function paginationWindow(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, function (_, i) { return i + 1; });
    }
    var pages = [1, current - 1, current, current + 1, total]
      .filter(function (page) { return page >= 1 && page <= total; })
      .filter(function (page, index, arr) { return arr.indexOf(page) === index; })
      .sort(function (a, b) { return a - b; });
    var output = [];
    pages.forEach(function (page, index) {
      if (index && page - pages[index - 1] > 1) output.push('gap-' + page);
      output.push(page);
    });
    return output;
  }

  function renderPagesPagination(root, totalRows, pageSize, currentPage, totalPages) {
    var pager = root.querySelector('[data-kpi-pages-pagination]');
    if (!pager) return;
    if (!totalRows || totalPages <= 1) {
      pager.innerHTML = totalRows ? '<span class="pkpi__pagination-count">' + totalRows + ' rows</span>' : '';
      return;
    }
    var start = (currentPage - 1) * pageSize + 1;
    var end = Math.min(totalRows, currentPage * pageSize);
    pager.innerHTML =
      '<span class="pkpi__pagination-count">Rows ' + start + '-' + end + ' of ' + totalRows + '</span>' +
      '<div class="pkpi__pagination-buttons">' +
      '<button type="button" data-kpi-page-jump="' + (currentPage - 1) + '"' + (currentPage === 1 ? ' disabled' : '') + '>Prev</button>' +
      paginationWindow(currentPage, totalPages).map(function (page) {
        if (typeof page !== 'number') return '<span class="pkpi__pagination-gap">...</span>';
        var active = page === currentPage ? ' class="pkpi__pagination-active"' : '';
        return '<button type="button"' + active + ' data-kpi-page-jump="' + page + '">' + page + '</button>';
      }).join('') +
      '<button type="button" data-kpi-page-jump="' + (currentPage + 1) + '"' + (currentPage === totalPages ? ' disabled' : '') + '>Next</button>' +
      '</div>';

    Array.prototype.forEach.call(pager.querySelectorAll('[data-kpi-page-jump]'), function (button) {
      button.addEventListener('click', function () {
        var next = parseInt(button.getAttribute('data-kpi-page-jump') || '1', 10);
        if (!Number.isFinite(next)) return;
        root.__pkpiPageNumber = Math.max(1, Math.min(totalPages, next));
        renderPages(root, getSelectedData(root.__pkpiData, root.__pkpiRangeId).pages);
      });
    });
  }

  function pageAuditRow(root, item) {
    var rows = root.__pkpiPerformancePayload && root.__pkpiPerformancePayload.siteAudit && root.__pkpiPerformancePayload.siteAudit.pageChecks;
    if (!Array.isArray(rows) || !item || !item.path) return null;
    var path = String(item.path);
    return rows.filter(function (row) {
      return String(row.path || '') === path;
    })[0] || null;
  }

  function pageAuditPriority(root, item) {
    var row = pageAuditRow(root, item);
    if (!row) return 9;
    if (row.ok !== true) return 0;
    if (row.isProduct && !row.hasAddToCart) return 1;
    if (!row.hasButtons) return 2;
    if (parseMetricNumber(row.ttfbMs) > 1200) return 3;
    return 8;
  }

  function pageAuditBadgeHtml(row) {
    if (!row) return '';
    var tone = sitePageTone(row);
    var label = row.ok !== true ? 'Not working'
      : row.isProduct && !row.hasAddToCart ? 'Missing cart'
        : !row.hasButtons ? 'No actions'
          : parseMetricNumber(row.ttfbMs) > 1200 ? 'Slow'
            : 'Working';
    return '<span class="pkpi__page-audit-badge pkpi__page-audit-badge--' + tone + '">' + escapeHtml(label) + '</span>';
  }

  function renderPages(root, items) {
    var target = root.querySelector('[data-kpi-pages]');
    if (!target) return;
    var pager = root.querySelector('[data-kpi-pages-pagination]');
    var pageSize = parseInt(root.getAttribute('data-kpi-page-size') || '6', 10);
    if (!Number.isFinite(pageSize) || pageSize < 2) pageSize = 6;
    if (pageSize > 12) pageSize = 12;
    var query = String(root.__pkpiSearch || '').trim();
    var filtered = Array.isArray(items) ? items.filter(function (item) {
      return pageMatchesQuery(item, query);
    }) : [];
    var sorted = sortPages(filtered, pageSortState(root));
    if (root.__pkpiPerformancePayload && root.__pkpiPerformancePayload.siteAudit) {
      sorted = sorted.slice().sort(function (a, b) {
        var priority = pageAuditPriority(root, a) - pageAuditPriority(root, b);
        return priority || 0;
      });
    }
    if (!filtered.length) {
      target.innerHTML = emptyMsg('No pages match.', 9);
      if (pager) pager.innerHTML = '';
      renderPageSortControls(root);
      return;
    }

    var totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
    var currentPage = Math.max(1, Math.min(totalPages, parseInt(root.__pkpiPageNumber || '1', 10) || 1));
    root.__pkpiPageNumber = currentPage;
    var start = (currentPage - 1) * pageSize;
    var visible = sorted.slice(start, start + pageSize);

    target.innerHTML = visible.map(function (item, idx) {
      var rowIndex = start + idx;
      var sessions = pagePeriodMetric(item, 'views');
      var shopifySessions = firstKnownMetric(item.shopifySessions);
      var shopifyPageviews = firstKnownMetric(item.shopifyPageviews);
      var clarityVisits = firstKnownMetric(item.clarityVisits, item.views, item.sessions);
      var auditRow = pageAuditRow(root, item);
      var auditNotes = [];
      if (auditRow) {
        auditNotes.push('Status ' + speedRowStatus(auditRow));
        auditNotes.push('TTFB ' + (auditRow.ttfb || '-'));
        auditNotes.push(auditRow.hasButtons ? 'actions present' : 'missing action signals');
        if (auditRow.isProduct) auditNotes.push(auditRow.hasAddToCart ? 'cart signal present' : 'missing cart signal');
      }
      var mainRow = '<tr class="pkpi__page-row-main" data-page-idx="' + rowIndex + '">' +
        '<td><span class="pkpi__path">' + escapeHtml(item.path) + '</span>' + pageAuditBadgeHtml(auditRow) + '<div class="pkpi__issue">' + escapeHtml(item.issue || '') + '</div></td>' +
        '<td>' + escapeHtml(sessions) + '</td>' +
        '<td>' + escapeHtml(item.engagedTime || '-') + '</td>' +
        '<td>' + escapeHtml(item.scrollDepth || '-') + '</td>' +
        '<td>' + escapeHtml(item.quickBacks || '-') + '</td>' +
        '<td>' + escapeHtml(item.rageClicks || '-') + '</td>' +
        '<td>' + escapeHtml(item.deadClicks || '-') + '</td>' +
        '<td>' + escapeHtml(item.exitRate || '-') + '</td>' +
        '<td><span class="pkpi__recommendation">' + escapeHtml(item.recommendation || '') + '</span></td>' +
        '</tr>';

      var detailRow = '<tr class="pkpi__page-detail-row" data-detail-for="' + rowIndex + '" hidden>' +
        '<td colspan="9"><div class="pkpi__page-detail">' +
        '<div class="pkpi__page-detail-stats">' +
        '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Shopify visitors</span><strong class="pkpi__page-detail-value">' + escapeHtml(sessions) + '</strong></div>' +
        (shopifySessions !== '-' ? '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Shopify sessions</span><strong class="pkpi__page-detail-value">' + escapeHtml(shopifySessions) + '</strong></div>' : '') +
        (shopifyPageviews !== '-' ? '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Shopify pageviews</span><strong class="pkpi__page-detail-value">' + escapeHtml(shopifyPageviews) + '</strong></div>' : '') +
        (clarityVisits !== '-' ? '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Clarity behavior rows</span><strong class="pkpi__page-detail-value">' + escapeHtml(clarityVisits) + '</strong></div>' : '') +
        '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Engaged time</span><strong class="pkpi__page-detail-value">' + escapeHtml(item.engagedTime || '—') + '</strong></div>' +
        '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Scroll depth</span><strong class="pkpi__page-detail-value">' + escapeHtml(item.scrollDepth || '—') + '</strong></div>' +
        '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Quick backs</span><strong class="pkpi__page-detail-value pkpi__page-detail-value--bad">' + escapeHtml(item.quickBacks || '—') + '</strong></div>' +
        '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Rage clicks</span><strong class="pkpi__page-detail-value pkpi__page-detail-value--bad">' + escapeHtml(item.rageClicks || '—') + '</strong></div>' +
        '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Dead clicks</span><strong class="pkpi__page-detail-value pkpi__page-detail-value--watch">' + escapeHtml(item.deadClicks || '—') + '</strong></div>' +
        '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Exit rate</span><strong class="pkpi__page-detail-value">' + escapeHtml(item.exitRate || '—') + '</strong></div>' +
        (auditRow ? '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">Site check</span><strong class="pkpi__page-detail-value pkpi__page-detail-value--' + sitePageTone(auditRow) + '">' + escapeHtml(speedRowStatus(auditRow)) + '</strong></div>' : '') +
        (auditRow ? '<div class="pkpi__page-detail-stat"><span class="pkpi__page-detail-label">TTFB</span><strong class="pkpi__page-detail-value">' + escapeHtml(auditRow.ttfb || '—') + '</strong></div>' : '') +
        '</div>' +
        (auditNotes.length ? '<p class="pkpi__page-detail-action">Site evidence: ' + escapeHtml(auditNotes.join(' - ')) + '</p>' : '') +
        (item.recommendation ? '<p class="pkpi__page-detail-action">→ ' + escapeHtml(item.recommendation) + '</p>' : '') +
        '</div></td></tr>';

      return mainRow + detailRow;
    }).join('');

    renderPagesPagination(root, sorted.length, pageSize, currentPage, totalPages);
    renderPageSortControls(root);

    Array.prototype.forEach.call(target.querySelectorAll('.pkpi__page-row-main'), function (row) {
      row.addEventListener('click', function () {
        var idx = row.getAttribute('data-page-idx');
        var detail = target.querySelector('[data-detail-for="' + idx + '"]');
        var isOpen = detail && !detail.hidden;
        Array.prototype.forEach.call(target.querySelectorAll('.pkpi__page-detail-row'), function (r) { r.hidden = true; });
        Array.prototype.forEach.call(target.querySelectorAll('.pkpi__page-row-main'), function (r) { r.classList.remove('pkpi__page-row-main--active'); });
        if (!isOpen && detail) {
          detail.hidden = false;
          row.classList.add('pkpi__page-row-main--active');
        }
      });
    });
  }

  // ── Traffic breakdowns ─────────────────────────────────────────────────────

  function renderBreakdown(root, selector, items) {
    var target = root.querySelector(selector);
    if (!target) return;
    if (!Array.isArray(items) || !items.length) { target.innerHTML = ''; return; }
    target.innerHTML = '<div class="pkpi__breakdown-card">' +
      items.map(function (item) {
        var pct = clampPercent(item.percent);
        return '<div class="pkpi__breakdown-row">' +
          '<div><strong>' + escapeHtml(item.label) + '</strong><span>' + escapeHtml(item.detail || '') + '</span></div>' +
          '<div class="pkpi__breakdown-meter">' +
          '<span class="pkpi__track"><span class="pkpi__bar' + toneClass('pkpi__bar', item.tone) + '" style="--pkpi-value:' + pct + '%"></span></span>' +
          '<b>' + escapeHtml(item.value) + '</b></div>' +
          '</div>';
      }).join('') + '</div>';
  }

  // ── Traffic breakdowns explanatory panel ───────────────────────────────────

  function renderTrafficBreakdowns(root, view) {
    var target = root.querySelector('[data-kpi-breakdowns]');
    if (!target) return;
    var devices = Array.isArray(view.devices) ? view.devices : [];
    var sources = Array.isArray(view.sources) ? view.sources : [];
    var breakdowns = Array.isArray(view.breakdowns) ? view.breakdowns : [];
    var hasBreakdownData = breakdowns.some(function (b) { return Array.isArray(b.items) && b.items.length > 0; });
    var audience = root.querySelector('[data-kpi-audience-section]');
    if (audience) audience.hidden = !devices.length && !sources.length;

    if (!devices.length && !sources.length && !hasBreakdownData) {
      target.innerHTML =
        '<div class="pkpi__traffic-note">' +
        '<p class="pkpi__traffic-note-title">Audience rows were requested automatically</p>' +
        '<p class="pkpi__traffic-note-body">Clarity returned URL-level data for this range, but no Device or Source rows. ' +
        'Reloading the page or changing range requests those breakdowns again automatically.</p>' +
        '</div>';
    } else if (hasBreakdownData) {
      target.innerHTML = breakdowns.filter(function (b) {
        return Array.isArray(b.items) && b.items.length > 0;
      }).map(function (panel) {
        var rows = panel.items.map(function (item) {
          var pct = clampPercent(item.percent);
          return '<div class="pkpi__breakdown-row">' +
            '<div><strong>' + escapeHtml(item.label) + '</strong>' +
            (item.detail ? '<span>' + escapeHtml(item.detail) + '</span>' : '') + '</div>' +
            '<div class="pkpi__breakdown-meter">' +
            '<span class="pkpi__track"><span class="pkpi__bar' + toneClass('pkpi__bar', item.tone) + '" style="--pkpi-value:' + pct + '%"></span></span>' +
            '<b>' + escapeHtml(item.value) + '</b></div></div>';
        }).join('');
        return '<div><h3 class="pkpi__sub-label">' + escapeHtml(panel.title || panel.label || '') + '</h3>' +
          '<div class="pkpi__breakdown-card">' + rows + '</div></div>';
      }).join('');
    }
  }

  // ── Events ─────────────────────────────────────────────────────────────────

  function renderEvents(root, items) {
    var target = root.querySelector('[data-kpi-events]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) { target.innerHTML = emptyMsg('No event data.'); return; }
    target.innerHTML = items.map(function (item) {
      var tone = item.tone && ['good', 'watch', 'bad'].indexOf(item.tone) !== -1 ? item.tone : 'neutral';
      return '<article class="pkpi__event pkpi__event--' + tone + '">' +
        '<span class="pkpi__small-label">' + escapeHtml(item.category) + '</span>' +
        '<strong>' + escapeHtml(item.name) + '</strong>' +
        '<dl><div><dt>Count</dt><dd>' + escapeHtml(item.count) + '</dd></div>' +
        '<div><dt>Rate</dt><dd>' + escapeHtml(item.rate) + '</dd></div>' +
        '<div><dt>Trend</dt><dd>' + escapeHtml(item.trend) + '</dd></div></dl>' +
        (item.detail ? '<p>' + escapeHtml(item.detail) + '</p>' : '') +
        '</article>';
    }).join('');
  }

  // ── Glossary ───────────────────────────────────────────────────────────────

  function renderGlossary(root, items) {
    var target = root.querySelector('[data-kpi-glossary]');
    if (!target) return;
    if (!Array.isArray(items) || !items.length) { target.innerHTML = emptyMsg('No definitions.'); return; }
    target.innerHTML = items.map(function (item) {
      return '<article class="pkpi__definition">' +
        '<h3>' + escapeHtml(item.term) + '</h3>' +
        '<p>' + escapeHtml(item.definition) + '</p>' +
        (item.read ? '<span>' + escapeHtml(item.read) + '</span>' : '') +
        '</article>';
    }).join('');
  }

  // ── Health command center ─────────────────────────────────────────────────

  function summaryItemByLabel(view, label) {
    var wanted = String(label || '').toLowerCase();
    var items = Array.isArray(view && view.summary) ? view.summary : [];
    return items.filter(function (item) {
      return String(item && item.label || '').toLowerCase() === wanted;
    })[0] || null;
  }

  function summaryDisplay(view, label, fallback) {
    var item = summaryItemByLabel(view, label);
    if (!item) return fallback || '-';
    return item.value == null || item.value === '' ? (fallback || '-') : item.value;
  }

  function sourceTimestamp(view, source) {
    var sources = view && view.dataSources || {};
    var row = sources[source] || {};
    if (row.updatedAt) return row.updatedAt;
    if (source === 'clarity') return view && (view.dataUpdatedAt || view.updatedAt) || '';
    return '';
  }

  function metricDetail(item, fallback) {
    return item && item.detail ? item.detail : fallback;
  }

  function noFactYet(label) {
    return 'No ' + label + ' fact yet. The separate performance/site endpoint is still loading.';
  }

  function healthToneForScore(score) {
    score = parseMetricNumber(score);
    if (score >= 80) return 'good';
    if (score >= 50) return 'watch';
    return 'bad';
  }

  function firstPerformanceRows(payload) {
    var auditRows = payload && payload.siteAudit && Array.isArray(payload.siteAudit.pageChecks) ? payload.siteAudit.pageChecks : [];
    var rows = Array.isArray(payload && payload.summary) ? payload.summary : [];
    return auditRows.length ? auditRows : rows;
  }

  function healthScoreHtml(view) {
    var health = view && view.health || {};
    if (view && view.behaviorUnavailable) {
      return '<article class="pkpi__health-score-card">' +
        '<div class="pkpi__health-score-top">' +
          '<div class="pkpi__health-score-copy">' +
            '<span class="pkpi__chart-eyebrow">Website score</span>' +
            '<h3>Behavior score unavailable</h3>' +
            '<p>Shopify commerce data is loaded for this period, but Clarity behavior rows are not available for the selected range.</p>' +
          '</div>' +
          '<div class="pkpi__health-score-number pkpi__health-score-number--watch">' +
            '<strong>-</strong><span>/100</span>' +
          '</div>' +
        '</div>' +
        '<div class="pkpi__health-score-meter pkpi__health-score-meter--watch"><i style="--pkpi-score:0%"></i></div>' +
        '<div class="pkpi__health-score-foot">' +
          '<span>Selected period: ' + escapeHtml(view.rangeLabel || rangeLabel(view.id)) + '</span>' +
          '<b>Shopify range loaded</b>' +
        '</div>' +
      '</article>';
    }
    var score = health.score != null ? health.score : parseMetricNumber(summaryDisplay(view, 'Health score', 0));
    var tone = health.tone || healthToneForScore(score);
    var gauge = clampPercent(score);
    var snapshot = sourceTimestamp(view, 'clarity');
    var period = view.rangeLabel || rangeLabel(view.id);
    var periodCopy = snapshot ? 'Clarity snapshot: ' + snapshot + ' · ' + period : 'Selected period: ' + period;
    return '<article class="pkpi__health-score-card">' +
      '<div class="pkpi__health-score-top">' +
        '<div class="pkpi__health-score-copy">' +
          '<span class="pkpi__chart-eyebrow">Website score</span>' +
          '<h3>' + escapeHtml(health.status || (score >= 80 ? 'Healthy' : score >= 50 ? 'Needs attention' : 'At risk')) + '</h3>' +
          '<p>Composite score from Clarity behavior signals. Use the cards below to open the supporting evidence.</p>' +
        '</div>' +
        '<div class="pkpi__health-score-number pkpi__health-score-number--' + escapeHtml(tone) + '">' +
          '<strong>' + escapeHtml(formatInteger(score)) + '</strong><span>/100</span>' +
        '</div>' +
      '</div>' +
      '<div class="pkpi__health-score-meter pkpi__health-score-meter--' + escapeHtml(tone) + '">' +
        '<i style="--pkpi-score:' + gauge + '%"></i>' +
      '</div>' +
      '<div class="pkpi__health-score-foot">' +
        '<span>' + escapeHtml(periodCopy) + '</span>' +
        '<b>' + escapeHtml((view.pages && view.pages.length ? formatInteger(view.pages.length) + ' behavior pages' : 'Behavior rows loading')) + '</b>' +
      '</div>' +
    '</article>';
  }

  function renderHealthScore(root, view) {
    var target = root.querySelector('[data-kpi-health-score]');
    if (target) target.innerHTML = healthScoreHtml(view);
  }

  function renderHealthKpis(root, view) {
    var target = root.querySelector('[data-kpi-health-kpis]');
    if (!target) return;
    var payload = root.__pkpiPerformancePayload || {};
    var audit = payload.siteAudit || {};
    var rows = firstPerformanceRows(payload);
    var speedScore = payload.averageScore != null ? parseMetricNumber(payload.averageScore) : fallbackSpeedScore(rows);
    var stats = speedStats(rows);
    var productTotal = parseMetricNumber(audit.productCount);
    var brokenCount = parseMetricNumber(audit.brokenCount);
    var missingCartCount = parseMetricNumber(audit.productMissingAddToCartCount);
    var sessionItem = summaryItemByLabel(view, 'Sessions') || summaryItemByLabel(view, 'Clarity sessions') || {};
    var avgEngagedItem = summaryItemByLabel(view, 'Avg engaged') || {};
    var avgScrollItem = summaryItemByLabel(view, 'Avg scroll') || {};
    var quickbackItem = summaryItemByLabel(view, 'Quickbacks') || {};
    var hasSpeedFacts = rows.length > 0;
    var usingHttpFallback = !!(payload && payload.limited);
    var speedValue = 'Loading';
    var speedTone = 'watch';
    var speedDetail = noFactYet('speed');
    if (hasSpeedFacts && usingHttpFallback) {
      speedValue = formatInteger(rows.length) + ' URLs';
      speedTone = 'neutral';
      speedDetail = speedDeviceLabel(payload.device || payload.preset) + ' HTTP timing fallback. Lighthouse/PageSpeed is unavailable for this run, so no lab score is shown here.';
    } else if (hasSpeedFacts) {
      speedValue = speedScore == null ? formatInteger(rows.length) + ' URLs' : String(Math.round(speedScore));
      speedTone = speedScore == null ? 'neutral' : speedToneForScore(speedScore);
      speedDetail = speedDeviceLabel(payload.device || payload.preset) + ' Lighthouse/PageSpeed audit across ' + formatInteger(rows.length) + ' URLs.';
    }
    var cards = [
      {
        label: 'Sessions',
        value: summaryDisplay(view, 'Sessions'),
        tone: sessionItem.tone || 'neutral',
        detail: metricDetail(sessionItem, 'Shopify Analytics sessions for the selected period.'),
        target: 'pages',
        action: 'sort-views'
      },
      {
        label: 'Speed',
        value: speedValue,
        tone: speedTone,
        detail: speedDetail,
        target: 'speed',
        action: 'speed-pages'
      },
      {
        label: 'Pages working',
        value: audit.checkedCount ? formatRatio(audit.okCount, audit.checkedCount) : 'Loading',
        tone: audit.checkedCount ? ratioTone(audit.okCount, audit.checkedCount) : 'watch',
        detail: audit.checkedCount ? (brokenCount ? formatInteger(brokenCount) + ' page checks need attention. Open Site Check for URLs, status codes, timing, and errors.' : 'All checked pages returned OK in the latest HTTP site check.') : noFactYet('site-check'),
        target: 'site',
        action: 'site-pages'
      },
      {
        label: 'Add to cart',
        value: productTotal ? formatRatio(audit.productAddToCartCount, productTotal) : 'Loading',
        tone: productTotal ? ratioTone(audit.productAddToCartCount, productTotal) : 'watch',
        detail: productTotal ? (missingCartCount ? formatInteger(missingCartCount) + ' product pages are missing cart signals in the latest site check.' : 'All checked product pages expose cart-form signals in the latest site check.') : noFactYet('add-to-cart site-check'),
        target: 'site',
        action: 'site-actions'
      },
      {
        label: 'Avg engaged',
        value: summaryDisplay(view, 'Avg engaged'),
        tone: avgEngagedItem.tone || 'neutral',
        detail: metricDetail(avgEngagedItem, 'Clarity active engagement time from the latest behavior snapshot.'),
        target: 'pages',
        action: 'sort-engaged'
      },
      {
        label: 'Avg scroll',
        value: summaryDisplay(view, 'Avg scroll'),
        tone: avgScrollItem.tone || 'neutral',
        detail: metricDetail(avgScrollItem, 'Clarity scroll depth from the latest behavior snapshot.'),
        target: 'pages',
        action: 'sort-scroll'
      },
      {
        label: 'Quickbacks',
        value: summaryDisplay(view, 'Quickbacks'),
        tone: quickbackItem.tone || 'neutral',
        detail: metricDetail(quickbackItem, 'Clarity quickback count from the latest behavior snapshot.'),
        target: 'pages',
        action: 'sort-quickbacks'
      },
      {
        label: 'p75 TTFB',
        value: stats.count ? formatDurationMs(stats.ttfbP75) : 'Loading',
        tone: stats.count ? speedToneForMetric('ttfb', stats.ttfbP75) : 'watch',
        detail: stats.count ? 'p75 server response time from the latest HTTP timing rows.' : noFactYet('TTFB'),
        target: 'speed',
        action: 'speed-pages'
      }
    ];
    target.innerHTML = cards.map(function (card) {
      return '<button type="button" class="pkpi__health-kpi pkpi__health-kpi--' + (card.tone || 'neutral') + '" data-kpi-health-link="' + escapeHtml(card.target || '') + '" data-kpi-health-action="' + escapeHtml(card.action || '') + '">' +
        '<span>' + escapeHtml(card.label) + '</span>' +
        '<strong>' + escapeHtml(card.value) + '</strong>' +
        '<p>' + escapeHtml(card.detail) + '</p>' +
        '<em>Open evidence</em>' +
      '</button>';
    }).join('');
  }

  function healthEvidenceSelector(action) {
    if (action === 'site-pages') return '[data-kpi-site-pages]';
    if (action === 'site-actions') return '[data-kpi-site-actions]';
    if (action === 'speed-pages') return '[data-kpi-speed-pages-title]';
    if (action === 'overview-seo') return '[data-kpi-health-seo]';
    if (action === 'sort-views' || action === 'sort-engaged' || action === 'sort-scroll' || action === 'sort-quickbacks') return '[data-kpi-pages]';
    return '';
  }

  function activateHealthLink(root, targetView, action) {
    targetView = targetView || 'overview';
    setActiveView(root, targetView);
    if (targetView === 'pages') {
      var sortKey = action === 'sort-engaged' ? 'engaged'
        : action === 'sort-scroll' ? 'scroll'
          : action === 'sort-quickbacks' ? 'quickBacks'
            : 'views';
      root.__pkpiPageSort = { key: sortKey, dir: sortKey === 'scroll' ? 'asc' : 'desc' };
      root.__pkpiPageNumber = 1;
      if (root.__pkpiData) {
        renderPages(root, getSelectedData(root.__pkpiData, root.__pkpiRangeId).pages);
      }
    }
    applyView(root);
    renderControls(root, root.__pkpiData, root.__pkpiRangeId);
    var selector = healthEvidenceSelector(action);
    if (selector) {
      window.setTimeout(function () {
        var el = root.querySelector(selector);
        var panel = el && (el.closest('section') || el);
        if (panel && typeof panel.scrollIntoView === 'function') {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 0);
    }
  }

  function bindHealthLinks(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-kpi-health-link]'), function (button) {
      if (button.dataset.kpiHealthBound) return;
      button.dataset.kpiHealthBound = '1';
      button.addEventListener('click', function () {
        activateHealthLink(root, button.getAttribute('data-kpi-health-link'), button.getAttribute('data-kpi-health-action'));
      });
    });
  }

  function pageQualityScore(page) {
    var sessions = parseMetricNumber(pagePeriodMetric(page, 'views'));
    var scroll = parseMetricNumber(page && page.scrollDepth);
    var engaged = secondsFromText(page && page.engagedTime);
    var quickbacks = parseMetricNumber(page && page.quickBacks);
    var rage = parseMetricNumber(page && page.rageClicks);
    var dead = parseMetricNumber(page && page.deadClicks);
    var errors = parseMetricNumber(page && page.scriptErrors) + parseMetricNumber(page && page.errorClicks);
    var score = 100;
    if (scroll > 0) score -= Math.max(0, 45 - scroll) * 0.75;
    if (engaged > 0) score += Math.min(8, engaged / 8);
    if (sessions > 0) {
      score -= Math.min(28, (quickbacks / sessions) * 220);
      score -= Math.min(26, ((rage + dead) / sessions) * 90);
      score -= Math.min(18, (errors / sessions) * 18);
    } else {
      score -= Math.min(24, quickbacks + rage + dead);
    }
    return Math.max(0, Math.min(100, Math.round(score)));
  }

  function pageQualityTone(score) {
    if (score >= 75) return 'good';
    if (score >= 50) return 'watch';
    return 'bad';
  }

  function pageQualityItems(view) {
    var pages = Array.isArray(view && view.pages) ? view.pages : [];
    return pages.map(function (page) {
      var score = pageQualityScore(page);
      var evidence = [];
      var sessions = pagePeriodMetric(page, 'views');
      if (sessions !== '-') evidence.push(sessions + ' Shopify visitors');
      if (page.clarityVisits && String(page.clarityVisits).trim() !== '-' && String(page.clarityVisits).trim() !== String(sessions).trim()) {
        evidence.push(page.clarityVisits + ' Clarity behavior rows');
      }
      if (page.scrollDepth && page.scrollDepth !== '-') evidence.push(page.scrollDepth + ' scroll');
      if (page.engagedTime && page.engagedTime !== '-') evidence.push(page.engagedTime + ' engaged');
      if (parseMetricNumber(page.quickBacks)) evidence.push(page.quickBacks + ' quickbacks');
      if (parseMetricNumber(page.rageClicks) || parseMetricNumber(page.deadClicks)) evidence.push((parseMetricNumber(page.rageClicks) + parseMetricNumber(page.deadClicks)) + ' rage/dead clicks');
      return {
        path: page.path || '',
        score: score,
        tone: pageQualityTone(score),
        evidence: evidence.join(' - ') || 'Behavior row from Clarity.',
        recommendation: page.recommendation || ''
      };
    }).sort(function (a, b) { return a.score - b.score; });
  }

  function renderHealthPageQuality(root, view) {
    var target = root.querySelector('[data-kpi-health-page-quality]');
    if (!target) return;
    var items = pageQualityItems(view).slice(0, 8);
    if (!items.length) {
      target.innerHTML = emptyMsg('No page behavior rows in this period.');
      return;
    }
    target.innerHTML = '<div class="pkpi__health-quality-list">' + items.map(function (item) {
      return '<div class="pkpi__health-quality-row pkpi__health-quality-row--' + item.tone + '">' +
        '<span title="' + escapeHtml(item.path) + '">' + escapeHtml(item.path || 'Untitled page') + '</span>' +
        '<b>' + escapeHtml(String(item.score)) + '/100</b>' +
        '<i style="--pkpi-quality:' + clampPercent(item.score) + '%"></i>' +
        '<p>' + escapeHtml(item.evidence + (item.recommendation ? ' - ' + item.recommendation : '')) + '</p>' +
      '</div>';
    }).join('') + '</div>';
  }

  function healthRouteForText(text) {
    text = String(text || '').toLowerCase();
    if (text.indexOf('speed') !== -1 || text.indexOf('ttfb') !== -1 || text.indexOf('server') !== -1 || text.indexOf('html') !== -1) {
      return { target: 'speed', action: 'speed-pages' };
    }
    if (text.indexOf('cart') !== -1 || text.indexOf('product') !== -1 || text.indexOf('commerce') !== -1) {
      return { target: 'site', action: 'site-actions' };
    }
    if (text.indexOf('page') !== -1 && (text.indexOf('working') !== -1 || text.indexOf('broken') !== -1 || text.indexOf('response') !== -1)) {
      return { target: 'site', action: 'site-pages' };
    }
    if (text.indexOf('quickback') !== -1) {
      return { target: 'pages', action: 'sort-quickbacks' };
    }
    if (text.indexOf('scroll') !== -1) {
      return { target: 'pages', action: 'sort-scroll' };
    }
    if (text.indexOf('friction') !== -1 || text.indexOf('rage') !== -1 || text.indexOf('dead') !== -1 || text.indexOf('health') !== -1) {
      return { target: 'pages', action: 'sort-quickbacks' };
    }
    if (text.indexOf('event') !== -1 || text.indexOf('tracker') !== -1 || text.indexOf('clarity') !== -1) {
      return { target: 'events', action: '' };
    }
    return { target: 'pages', action: 'sort-views' };
  }

  function healthRowAttrs(item) {
    if (!item || !item.target) return '';
    return ' data-kpi-health-link="' + escapeHtml(item.target) + '" data-kpi-health-action="' + escapeHtml(item.action || '') + '"';
  }

  function healthAlertItems(root, view) {
    function alertLabel(label) {
      var normalized = String(label || '').toLowerCase();
      if (normalized === 'health score' || normalized === 'health') return 'Score';
      return label || 'Evidence';
    }
    var items = [];
    var insights = Array.isArray(view && view.insights) ? view.insights : [];
    insights.forEach(function (insight) {
      if (insight.tone === 'bad' || insight.tone === 'watch') {
        var route = healthRouteForText([insight.label, insight.title, insight.detail, insight.action].join(' '));
        items.push({
          tone: insight.tone,
          title: insight.title || insight.label,
          detail: (insight.detail || '') + (insight.action ? ' Next: ' + insight.action : ''),
          value: alertLabel(insight.label || 'Clarity'),
          target: route.target,
          action: route.action
        });
      }
    });
    var diagnostics = Array.isArray(view && view.diagnostics) ? view.diagnostics : [];
    diagnostics.forEach(function (diag) {
      if (diag.tone === 'bad' || diag.tone === 'watch') {
        var route = healthRouteForText([diag.area, diag.problem, diag.evidence, diag.next].join(' '));
        items.push({
          tone: diag.tone,
          title: diag.problem || diag.area,
          detail: (diag.evidence || '') + (diag.next ? ' Next: ' + diag.next : ''),
          value: alertLabel(diag.area || 'Diagnostic'),
          target: route.target,
          action: route.action
        });
      }
    });
    var payload = root.__pkpiPerformancePayload || {};
    var rows = firstPerformanceRows(payload);
    var stats = speedStats(rows);
    var speedScore = payload.averageScore != null ? parseMetricNumber(payload.averageScore) : fallbackSpeedScore(rows);
    if (speedScore != null && speedScore < 90) {
      items.push({
        tone: speedToneForScore(speedScore),
        title: 'Speed needs attention',
        detail: 'Latest ' + speedDeviceLabel(payload.device || payload.preset) + ' score is ' + Math.round(speedScore) + '. p75 TTFB is ' + formatDurationMs(stats.ttfbP75) + ' and p75 HTML is ' + formatBytesValue(stats.sizeP75) + '.',
        value: 'Speed',
        target: 'speed',
        action: 'speed-pages'
      });
    }
    var audit = payload.siteAudit || {};
    if (parseMetricNumber(audit.brokenCount) > 0) {
      items.push({
        tone: 'bad',
        title: 'Some tracked pages are not working',
        detail: formatInteger(audit.brokenCount) + ' of ' + formatInteger(audit.checkedCount) + ' checked URLs did not return OK.',
        value: 'Site',
        target: 'site',
        action: 'site-pages'
      });
    }
    if (parseMetricNumber(audit.productMissingAddToCartCount) > 0) {
      items.push({
        tone: 'bad',
        title: 'Product add-to-cart signals are missing',
        detail: formatInteger(audit.productMissingAddToCartCount) + ' product pages did not expose an add-to-cart/product-form signal.',
        value: 'Cart',
        target: 'site',
        action: 'site-actions'
      });
    }
    var seo = audit.seoChecks || {};
    if (seo.checkedCount && (seo.missingTitleCount || seo.missingMetaDescriptionCount || seo.missingCanonicalCount || seo.noindexCount)) {
      items.push({
        tone: seo.noindexCount ? 'bad' : 'watch',
        title: 'SEO basics need review',
        detail: formatInteger((seo.missingTitleCount || 0) + (seo.missingMetaDescriptionCount || 0) + (seo.missingCanonicalCount || 0) + (seo.noindexCount || 0)) + ' basic indexability signals need attention.',
        value: 'SEO',
        target: 'overview',
        action: 'overview-seo'
      });
    }
    return items.slice(0, 8);
  }

  function renderHealthAlerts(root, view) {
    var target = root.querySelector('[data-kpi-health-alerts]');
    if (!target) return;
    var items = healthAlertItems(root, view);
    if (!items.length) {
      target.innerHTML = '<div class="pkpi__health-list"><article class="pkpi__health-row pkpi__health-row--good"><div><h4>No urgent alerts in this snapshot</h4><p>Current source data did not return critical behavior, speed, site, or SEO warnings.</p></div><strong>OK</strong></article></div>';
      return;
    }
    target.innerHTML = '<div class="pkpi__health-list">' + items.map(function (item) {
      return '<button type="button" class="pkpi__health-row pkpi__health-row--' + (item.tone || 'watch') + '"' + healthRowAttrs(item) + '>' +
        '<div><h4>' + escapeHtml(item.title || '') + '</h4><p>' + escapeHtml(item.detail || '') + '</p></div>' +
        '<strong>' + escapeHtml(item.value || '') + '</strong>' +
      '</button>';
    }).join('') + '</div>';
  }

  function renderHealthFixQueue(root, view) {
    var target = root.querySelector('[data-kpi-health-fix-queue]');
    if (!target) return;
    var items = [];
    (Array.isArray(view && view.priorities) ? view.priorities : []).slice(0, 4).forEach(function (item) {
      var route = healthRouteForText([item.title, item.metric, item.action, item.detail, item.evidence].join(' '));
      items.push({
        tone: item.tone || 'watch',
        title: item.title || item.metric || 'Behavior issue',
        detail: item.action || (Array.isArray(item.actions) && item.actions[0]) || item.detail || item.evidence || '',
        value: item.value || item.page || 'Clarity',
        target: route.target,
        action: route.action
      });
    });
    var payload = root.__pkpiPerformancePayload || {};
    var rows = firstPerformanceRows(payload);
    var stats = speedStats(rows);
    var audit = payload.siteAudit || {};
    if (stats.slowTtfbCount > 0) {
      items.push({
        tone: stats.badTtfbCount ? 'bad' : 'watch',
        title: 'Reduce slow server responses',
        detail: formatInteger(stats.slowTtfbCount) + ' checked URLs are over the TTFB target. Start with ' + speedRowLabel(worstSpeedRow(rows, 'ttfb')) + '.',
        value: formatDurationMs(stats.ttfbP75),
        target: 'speed',
        action: 'speed-pages'
      });
    }
    if (stats.heavyCount > 0) {
      items.push({
        tone: stats.veryHeavyCount ? 'bad' : 'watch',
        title: 'Reduce heavy HTML',
        detail: formatInteger(stats.heavyCount) + ' checked URLs are over the HTML weight target. Start with ' + speedRowLabel(worstSpeedRow(rows, 'size')) + '.',
        value: formatBytesValue(stats.sizeP75),
        target: 'speed',
        action: 'speed-pages'
      });
    }
    if (parseMetricNumber(audit.productMissingAddToCartCount) > 0) {
      items.push({
        tone: 'bad',
        title: 'Fix product add-to-cart coverage',
        detail: 'Make sure product forms render for every checked product page, including mobile.',
        value: formatRatio(audit.productAddToCartCount, audit.productCount),
        target: 'site',
        action: 'site-actions'
      });
    }
    var seo = audit.seoChecks || {};
    if (seo.checkedCount && seo.missingMetaDescriptionCount) {
      items.push({
        tone: 'watch',
        title: 'Fill missing meta descriptions',
        detail: formatInteger(seo.missingMetaDescriptionCount) + ' checked pages are missing a meta description in the rendered HTML.',
        value: formatRatio(seo.metaDescriptionCount, seo.checkedCount),
        target: 'overview',
        action: 'overview-seo'
      });
    }
    if (!items.length) {
      items.push({
        tone: 'good',
        title: 'Keep monitoring',
        detail: 'No fix queue items were generated from the current source data.',
        value: 'OK'
      });
    }
    items.sort(function (a, b) {
      var order = { bad: 0, watch: 1, neutral: 2, good: 3 };
      return (order[a.tone] == null ? 2 : order[a.tone]) - (order[b.tone] == null ? 2 : order[b.tone]);
    });
    target.innerHTML = '<div class="pkpi__health-list">' + items.slice(0, 6).map(function (item) {
      return '<button type="button" class="pkpi__health-row pkpi__health-row--' + (item.tone || 'watch') + '"' + healthRowAttrs(item) + '>' +
        '<div><h4>' + escapeHtml(item.title || '') + '</h4><p>' + escapeHtml(item.detail || '') + '</p></div>' +
        '<strong>' + escapeHtml(item.value || '') + '</strong>' +
      '</button>';
    }).join('') + '</div>';
  }

  function renderHealthTrends(root, view) {
    var target = root.querySelector('[data-kpi-health-trends]');
    if (!target) return;
    var ranges = getRanges(root.__pkpiData) || [];
    var labels = ['Health score', 'Sessions', 'Avg engaged', 'Avg scroll', 'Quickbacks', 'Script errors'];
    var available = ranges.filter(function (range) { return !range.rangeUnavailable; });
    if (available.length < 2) {
      target.innerHTML = emptyMsg('Load another time period to compare trends.');
      return;
    }
    target.innerHTML = '<div class="pkpi__health-list">' + labels.map(function (label) {
      var current = summaryDisplay(view, label);
      var parts = available.map(function (range) {
        return rangeLabel(range.id) + ': ' + summaryDisplay(range, label);
      }).join(' - ');
      return '<article class="pkpi__health-row">' +
        '<div><h4>' + escapeHtml(label === 'Health score' ? 'Website score' : label) + '</h4><p>' + escapeHtml(parts) + '</p></div>' +
        '<strong>' + escapeHtml(current) + '</strong>' +
      '</article>';
    }).join('') + '</div>';
  }

  function renderHealthJourney(root, view) {
    var target = root.querySelector('[data-kpi-health-journey]');
    if (!target) return;
    var items = Array.isArray(view && view.funnel) ? view.funnel : [];
    if (!items.length) {
      target.innerHTML = emptyMsg('No conversion journey data for this period.');
      return;
    }
    target.innerHTML = '<div class="pkpi__health-journey">' + items.map(function (item) {
      var tone = item.tone || 'watch';
      return '<div class="pkpi__health-step pkpi__health-step--' + tone + '">' +
        '<span>' + escapeHtml(item.label || '') + '</span>' +
        '<b>' + escapeHtml(item.value || '') + '</b>' +
        '<i style="--pkpi-step:' + clampPercent(item.percent) + '%"></i>' +
      '</div>';
    }).join('') + '</div>';
  }

  function renderHealthSeo(root) {
    var target = root.querySelector('[data-kpi-health-seo]');
    if (!target) return;
    var payload = root.__pkpiPerformancePayload || {};
    var seo = payload.siteAudit && payload.siteAudit.seoChecks || {};
    if (!seo.checkedCount) {
      target.innerHTML = emptyMsg('SEO basics will appear after the site check finishes.');
      return;
    }
    var imageAltValue = seo.imageCount ? formatRatio(seo.imageAltCount, seo.imageCount) : 'No images';
    var checks = [
      { label: 'Titles', value: formatRatio(seo.titleCount, seo.checkedCount), tone: ratioTone(seo.titleCount, seo.checkedCount), detail: 'Pages with a title tag.' },
      { label: 'Meta descriptions', value: formatRatio(seo.metaDescriptionCount, seo.checkedCount), tone: ratioTone(seo.metaDescriptionCount, seo.checkedCount), detail: 'Pages with a description snippet.' },
      { label: 'Canonicals', value: formatRatio(seo.canonicalCount, seo.checkedCount), tone: ratioTone(seo.canonicalCount, seo.checkedCount), detail: 'Pages with canonical URL tags.' },
      { label: 'One H1', value: formatRatio(seo.h1OkCount, seo.checkedCount), tone: ratioTone(seo.h1OkCount, seo.checkedCount), detail: 'Pages with exactly one main H1.' },
      { label: 'Noindex', value: formatInteger(seo.noindexCount || 0), tone: seo.noindexCount ? 'bad' : 'good', detail: 'Checked pages that tell search engines not to index.' },
      { label: 'Image alt text', value: imageAltValue, tone: seo.imageCount ? ratioTone(seo.imageAltCount, seo.imageCount) : 'neutral', detail: 'Images with alt attributes in rendered HTML.' }
    ];
    target.innerHTML = '<div class="pkpi__health-list">' + checks.map(function (check) {
      return '<article class="pkpi__health-row pkpi__health-row--' + (check.tone || 'neutral') + '">' +
        '<div><h4>' + escapeHtml(check.label) + '</h4><p>' + escapeHtml(check.detail) + '</p></div>' +
        '<strong>' + escapeHtml(check.value) + '</strong>' +
      '</article>';
    }).join('') + '</div>';
  }

  function renderHealthSources(root, view) {
    var target = root.querySelector('[data-kpi-health-sources]');
    if (!target) return;
    var payload = root.__pkpiPerformancePayload || {};
    var audit = payload.siteAudit || {};
    var data = root.__pkpiData || {};
    var sources = view.dataSources || {};
    var clarity = sources.clarity || {};
    var shopify = sources.shopify || {};
    var shopifyStats = view.shopify || {};
    var analytics = shopifyStats.analytics || {};
    var analyticsStatus = analytics.status === 'fresh'
      ? ('Sessions query: ' + (analytics.query || 'ShopifyQL'))
      : (view.shopifyAnalyticsStatusLabel || analytics.message || 'Not available');
    var rows = [
      ['Overall status', view.statusLabel || data.feedStatus || 'Connected'],
      ['Clarity period', clarity.rangeLabel || view.rangeLabel || rangeLabel(view.id)],
      ['Clarity snapshot', clarity.updatedAt || view.dataUpdatedAt || view.updatedAt || '-'],
      ['Clarity checked', clarity.checkedAt || view.checkedAt || data.feedCheckedAt || '-'],
      ['Behavior rows', Array.isArray(view.pages) ? formatInteger(view.pages.length) : '-'],
      ['Shopify period', shopify.rangeLabel || view.shopifyRangeLabel || '-'],
      ['Shopify orders', shopifyStats.orders != null ? formatInteger(shopifyStats.orders) + ' non-cancelled orders' : (data.shopifyAvailable ? 'Connected' : 'Not connected')],
      ['Shopify Analytics', analyticsStatus],
      ['Speed source', payload.source || 'Loading separate performance endpoint'],
      ['Speed updated', payload.updatedAt || 'Loading'],
      ['Speed device', payload.device ? speedDeviceLabel(payload.device) : speedDeviceLabel(currentSpeedDevice(root))],
      ['Speed limitation', payload.warning || (payload.limited ? 'HTTP timing fallback only' : 'None reported')],
      ['Site checked', audit.checkedCount ? formatInteger(audit.checkedCount) + ' URLs' : 'Loading'],
      ['Site range', audit.range || currentPerformanceRange(root)]
    ];
    target.innerHTML = '<div class="pkpi__health-source-list"><dl>' + rows.map(function (row) {
      return '<dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd>';
    }).join('') + '</dl></div>';
  }

  function renderHealthCommandCenter(root, view) {
    if (!root.querySelector('[data-kpi-view="overview"]')) return;
    renderHealthScore(root, view);
    renderHealthKpis(root, view);
    renderHealthAlerts(root, view);
    renderHealthFixQueue(root, view);
    renderHealthTrends(root, view);
    renderHealthJourney(root, view);
    renderHealthPageQuality(root, view);
    renderHealthSeo(root);
    renderHealthSources(root, view);
    bindHealthLinks(root);
  }

  function renderCurrentHealth(root) {
    if (!root.__pkpiData) return;
    renderHealthCommandCenter(root, getSelectedData(root.__pkpiData, root.__pkpiRangeId));
  }

  // ── Website speed audit ───────────────────────────────────────────────────

  function setSpeedText(root, selector, value) {
    var target = root.querySelector(selector);
    if (target) target.textContent = value || '';
  }

  function normalizeSpeedDevice(value) {
    return String(value || '').toLowerCase() === 'mobile' ? 'mobile' : 'desktop';
  }

  function currentSpeedDevice(root) {
    root.__pkpiSpeedDevice = normalizeSpeedDevice(root.__pkpiSpeedDevice || root.getAttribute('data-kpi-speed-device') || 'desktop');
    return root.__pkpiSpeedDevice;
  }

  function currentPerformanceRange(root) {
    var id = String(root.__pkpiRangeId || (root.__pkpiData && root.__pkpiData.defaultRange) || '1d').toLowerCase();
    return ['1d', '3d', '7d', '14d', 'custom'].indexOf(id) !== -1 ? id : '1d';
  }

  function speedDeviceLabel(device) {
    return normalizeSpeedDevice(device) === 'mobile' ? 'Mobile' : 'Desktop';
  }

  function performanceSourceIsDynamic(root) {
    var source = String(root.getAttribute('data-kpi-speed-source') || '');
    return /\/api\/performance-kpis(?:\?|$)/.test(source);
  }

  function renderDeviceToggles(root) {
    var device = currentSpeedDevice(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-kpi-device-toggle]'), function (toggle) {
      Array.prototype.forEach.call(toggle.querySelectorAll('[data-kpi-device-option]'), function (button) {
        var option = normalizeSpeedDevice(button.getAttribute('data-kpi-device-option'));
        var active = option === device;
        button.classList.toggle('pkpi__device-option--active', active);
        button.classList.remove('pkpi__device-option--disabled');
        button.disabled = false;
        button.title = '';
        button.removeAttribute('aria-disabled');
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (!button.dataset.kpiDeviceBound) {
          button.dataset.kpiDeviceBound = '1';
          button.addEventListener('click', function () {
            var next = normalizeSpeedDevice(button.getAttribute('data-kpi-device-option'));
            if (next === currentSpeedDevice(root)) return;
            root.__pkpiSpeedDevice = next;
            renderDeviceToggles(root);
            renderSiteAuditLoading(root);
            runSpeedAudit(root, false);
          });
        }
      });
    });
  }

  function metricDisplay(row, key, fallback) {
    if (!row) return fallback || '-';
    return row[key] || row[key + 'Display'] || fallback || '-';
  }

  function metricNumberFromRow(row, key) {
    if (!row) return 0;
    var raw = row[key + 'Ms'];
    if (raw == null && key === 'cls') raw = row.clsNumeric;
    if (raw == null && key === 'size') raw = row.sizeBytes;
    if (raw == null) raw = row[key];
    return parseMetricNumber(raw);
  }

  function worstSpeedRow(rows, key) {
    if (!Array.isArray(rows) || !rows.length) return null;
    return rows.slice().sort(function (a, b) {
      return metricNumberFromRow(b, key) - metricNumberFromRow(a, key);
    })[0];
  }

  function speedRowLabel(row) {
    if (!row) return 'site';
    if (row.path) return row.path === '/' ? 'Homepage' : row.path;
    if (row.label) return row.label;
    var url = String(row.url || '');
    if (!url) return 'site';
    try {
      var parsed = new URL(url);
      return parsed.pathname === '/' ? 'Homepage' : parsed.pathname.replace(/^\/products\//, 'PDP: ');
    } catch (e) {
      return url;
    }
  }

  function averageSpeedScore(rows) {
    if (!Array.isArray(rows) || !rows.length) return null;
    var scores = rows.map(function (row) { return parseMetricNumber(row.score); }).filter(function (score) { return score > 0; });
    if (!scores.length) return null;
    return Math.round(scores.reduce(function (sum, score) { return sum + score; }, 0) / scores.length);
  }

  function speedToneForScore(score) {
    if (score >= 90) return 'good';
    if (score >= 50) return 'watch';
    return 'bad';
  }

  function scoreFromThreshold(value, goodMax, poorMax) {
    value = parseMetricNumber(value);
    if (!value) return 50;
    if (value <= goodMax) return 100;
    if (value <= poorMax) {
      return 90 - ((value - goodMax) / (poorMax - goodMax)) * 40;
    }
    return Math.max(0, 49 - ((value - poorMax) / poorMax) * 30);
  }

  function fallbackSpeedScore(rows) {
    if (!Array.isArray(rows) || !rows.length) return null;
    var stats = speedStats(rows);
    var ttfb = scoreFromThreshold(stats.ttfbP75, 800, 1800);
    var total = scoreFromThreshold(stats.totalP75, 1500, 3000);
    var size = scoreFromThreshold(stats.sizeP75, 300000, 600000);
    return Math.max(0, Math.min(100, Math.round((ttfb * 0.45) + (total * 0.35) + (size * 0.2))));
  }

  function setSpeedScoreRing(root, score) {
    var ring = root.querySelector('[data-kpi-speed-score-ring]');
    if (!ring) return;
    var value = Math.max(0, Math.min(100, parseMetricNumber(score)));
    ring.style.setProperty('--pkpi-score', value);
    ring.setAttribute('data-tone', score == null ? 'watch' : speedToneForScore(value));
  }

  function speedToneForMetric(key, value) {
    if (key === 'lcp') return value <= 2500 ? 'good' : value <= 4000 ? 'watch' : 'bad';
    if (key === 'tbt') return value <= 200 ? 'good' : value <= 600 ? 'watch' : 'bad';
    if (key === 'cls') return value <= 0.1 ? 'good' : value <= 0.25 ? 'watch' : 'bad';
    if (key === 'ttfb') return value <= 800 ? 'good' : value <= 1800 ? 'watch' : 'bad';
    if (key === 'total') return value <= 1500 ? 'good' : value <= 3000 ? 'watch' : 'bad';
    if (key === 'size') return value <= 300000 ? 'good' : value <= 600000 ? 'watch' : 'bad';
    return 'watch';
  }

  function speedIssueTitle(score, rows) {
    if (!Array.isArray(rows) || !rows.length) return 'Speed audit did not finish.';
    if (score >= 90) return 'Website speed looks healthy in the latest audit.';
    if (score >= 50) return 'Website speed needs a focused cleanup pass.';
    return 'Website speed is a conversion risk on mobile.';
  }

  function speedIssueSummary(rows) {
    if (!Array.isArray(rows) || !rows.length) {
      return 'The local server could not return Lighthouse or PageSpeed results yet.';
    }
    return rows.map(function (row) {
      return speedRowLabel(row) + ': score ' + (row.score || '-') +
        ', LCP ' + metricDisplay(row, 'lcp') +
        ', TBT ' + metricDisplay(row, 'tbt') +
        ', CLS ' + metricDisplay(row, 'cls');
    }).join(' | ');
  }

  function psiMetricHtml(card) {
    return '<article class="pkpi__psi-metric pkpi__psi-metric--' + (card.tone || 'watch') + '">' +
      '<span>' + escapeHtml(card.label || '') + '</span>' +
      '<strong>' + escapeHtml(card.value || '-') + '</strong>' +
      '<p>' + escapeHtml(card.detail || '') + '</p>' +
      '<em>' + escapeHtml(card.target || '') + '</em>' +
      '</article>';
  }

  function speedVitalsHtml(rows) {
    var lcp = worstSpeedRow(rows, 'lcp');
    var tbt = worstSpeedRow(rows, 'tbt');
    var cls = worstSpeedRow(rows, 'cls');
    var ttfb = worstSpeedRow(rows, 'ttfb');
    var cards = [
      { key: 'lcp', label: 'LCP', target: '< 2.5s', row: lcp, detail: 'Largest first-viewport image or block.' },
      { key: 'tbt', label: 'TBT', target: '< 200ms', row: tbt, detail: 'Lab proxy for interaction delay and INP risk.' },
      { key: 'cls', label: 'CLS', target: '< 0.10', row: cls, detail: 'Layout movement from media, banners, and app blocks.' },
      { key: 'ttfb', label: 'TTFB', target: '< 0.8s', row: ttfb, detail: 'Server and app response before rendering starts.' },
    ];
    return cards.map(function (card) {
      var value = metricNumberFromRow(card.row, card.key);
      var tone = card.row ? speedToneForMetric(card.key, value) : 'watch';
      return psiMetricHtml({
        label: card.label,
        value: card.row ? metricDisplay(card.row, card.key, card.target) : card.target,
        detail: card.row ? speedRowLabel(card.row) + ' - ' + card.detail : card.detail,
        target: 'Target ' + card.target,
        tone: tone
      });
    }).join('');
  }

  function deriveSpeedConcerns(rows, score) {
    if (!Array.isArray(rows) || !rows.length) return [];
    var lcp = worstSpeedRow(rows, 'lcp');
    var tbt = worstSpeedRow(rows, 'tbt');
    var cls = worstSpeedRow(rows, 'cls');
    var ttfb = worstSpeedRow(rows, 'ttfb');
    return [
      {
        rank: '1',
        tone: speedToneForMetric('lcp', metricNumberFromRow(lcp, 'lcp')),
        title: 'Largest contentful paint',
        detail: speedRowLabel(lcp) + ' is at ' + metricDisplay(lcp, 'lcp') + '. Compress and preload the real first-viewport image.'
      },
      {
        rank: '2',
        tone: speedToneForMetric('tbt', metricNumberFromRow(tbt, 'tbt')),
        title: 'JavaScript blocking time',
        detail: speedRowLabel(tbt) + ' has ' + metricDisplay(tbt, 'tbt') + ' total blocking time. Keep apps and widgets template-scoped.'
      },
      {
        rank: '3',
        tone: speedToneForMetric('cls', metricNumberFromRow(cls, 'cls')),
        title: 'Layout stability',
        detail: speedRowLabel(cls) + ' has CLS ' + metricDisplay(cls, 'cls') + '. Reserve media, banner, and app-block space.'
      },
      {
        rank: '4',
        tone: speedToneForScore(score || 0),
        title: 'Overall mobile score',
        detail: 'Average score is ' + (score == null ? '-' : score) + '. Re-test after image, script, and layout fixes.'
      },
      {
        rank: '5',
        tone: speedToneForMetric('ttfb', metricNumberFromRow(ttfb, 'ttfb')),
        title: 'Server response',
        detail: speedRowLabel(ttfb) + ' TTFB is ' + metricDisplay(ttfb, 'ttfb') + '. Watch Shopify app and Liquid response overhead.'
      }
    ];
  }

  function speedConcernsHtml(concerns) {
    if (!Array.isArray(concerns) || !concerns.length) {
      return '<article class="pkpi__speed-concern pkpi__speed-concern--watch">' +
        '<span>!</span><h4>No speed result yet</h4>' +
        '<p>The local audit is still running or could not start. Check the status card above.</p></article>';
    }
    return concerns.slice(0, 5).map(function (item, index) {
      var tone = item.tone || 'watch';
      return '<article class="pkpi__speed-concern pkpi__speed-concern--' + tone + '">' +
        '<span>' + escapeHtml(item.rank || index + 1) + '</span>' +
        '<h4>' + escapeHtml(item.title || '') + '</h4>' +
        '<p>' + escapeHtml(item.detail || item.action || '') + '</p>' +
        '</article>';
    }).join('');
  }

  function formatDurationMs(value, fallback) {
    var n = parseMetricNumber(value);
    if (!n) return fallback || '-';
    if (n >= 1000) {
      var seconds = n / 1000;
      var places = seconds >= 10 ? 1 : 2;
      return seconds.toFixed(places).replace(/\.0+$/, '').replace(/(\.\d)0$/, '$1') + 's';
    }
    return Math.round(n) + 'ms';
  }

  function formatBytesValue(value, fallback) {
    var n = parseMetricNumber(value);
    if (!n) return fallback || '-';
    if (n >= 1048576) return (n / 1048576).toFixed(1).replace(/\.0$/, '') + ' MB';
    return Math.round(n / 1024).toLocaleString('en-US') + ' KB';
  }

  function speedMetricDisplay(row, key, fallback) {
    var value = metricNumberFromRow(row, key);
    if (key === 'size') return metricDisplay(row, key, formatBytesValue(value, fallback));
    if (key === 'cls') return metricDisplay(row, key, value ? value.toFixed(3).replace(/0+$/, '').replace(/\.$/, '') : fallback || '-');
    return metricDisplay(row, key, formatDurationMs(value, fallback));
  }

  function speedRowsForMetric(rows, key) {
    if (!Array.isArray(rows)) return [];
    return rows.filter(function (row) {
      return metricNumberFromRow(row, key) > 0;
    }).sort(function (a, b) {
      return metricNumberFromRow(b, key) - metricNumberFromRow(a, key);
    });
  }

  function speedValues(rows, key) {
    return speedRowsForMetric(rows, key).map(function (row) {
      return metricNumberFromRow(row, key);
    });
  }

  function speedAverage(values) {
    if (!values.length) return 0;
    return values.reduce(function (sum, value) { return sum + value; }, 0) / values.length;
  }

  function speedPercentile(values, percentile) {
    if (!values.length) return 0;
    var sorted = values.slice().sort(function (a, b) { return a - b; });
    var index = Math.max(0, Math.min(sorted.length - 1, Math.ceil((percentile / 100) * sorted.length) - 1));
    return sorted[index];
  }

  function speedStatusOk(row) {
    if (!row) return false;
    var hasCode = row.statusCode != null && String(row.statusCode).trim() !== '';
    var code = parseMetricNumber(row.statusCode);
    if (hasCode) return code >= 200 && code < 400;
    if (row.ok === true) return true;
    if (row.ok === false) return false;
    return true;
  }

  function speedStats(rows) {
    rows = Array.isArray(rows) ? rows.filter(Boolean) : [];
    var ttfb = speedValues(rows, 'ttfb');
    var total = speedValues(rows, 'total');
    var size = speedValues(rows, 'size');
    var statusRows = rows.filter(function (row) {
      return row && (row.statusCode != null || row.ok != null);
    });
    var okRows = statusRows.filter(speedStatusOk);
    return {
      count: rows.length,
      statusCount: statusRows.length,
      okCount: okRows.length,
      ttfbAvg: speedAverage(ttfb),
      ttfbP75: speedPercentile(ttfb, 75),
      ttfbP95: speedPercentile(ttfb, 95),
      totalAvg: speedAverage(total),
      totalP75: speedPercentile(total, 75),
      totalP95: speedPercentile(total, 95),
      sizeAvg: speedAverage(size),
      sizeP75: speedPercentile(size, 75),
      sizeP95: speedPercentile(size, 95),
      slowTtfbCount: ttfb.filter(function (value) { return value > 800; }).length,
      badTtfbCount: ttfb.filter(function (value) { return value > 1800; }).length,
      slowTotalCount: total.filter(function (value) { return value > 1500; }).length,
      badTotalCount: total.filter(function (value) { return value > 3000; }).length,
      heavyCount: size.filter(function (value) { return value > 300000; }).length,
      veryHeavyCount: size.filter(function (value) { return value > 600000; }).length
    };
  }

  function speedBucketRows(values, goodMax, watchMax) {
    return [
      { label: 'Good', tone: 'good', count: values.filter(function (value) { return value > 0 && value <= goodMax; }).length },
      { label: 'Needs work', tone: 'watch', count: values.filter(function (value) { return value > goodMax && value <= watchMax; }).length },
      { label: 'High risk', tone: 'bad', count: values.filter(function (value) { return value > watchMax; }).length }
    ];
  }

  function speedBucketCard(title, summary, values, goodMax, watchMax) {
    var total = values.length || 0;
    var buckets = speedBucketRows(values, goodMax, watchMax);
    return '<article class="pkpi__speed-bucket-card">' +
      '<h4>' + escapeHtml(title) + '</h4>' +
      '<p>' + escapeHtml(summary) + '</p>' +
      '<div class="pkpi__speed-bucket-bars">' +
      buckets.map(function (bucket) {
        var pct = total ? Math.round((bucket.count / total) * 100) : 0;
        return '<div class="pkpi__speed-bucket-row pkpi__speed-bucket-row--' + bucket.tone + '">' +
          '<div><strong>' + escapeHtml(bucket.label) + '</strong><span>' + escapeHtml(formatInteger(bucket.count) + ' pages') + '</span></div>' +
          '<div class="pkpi__speed-bucket-meter"><i style="width:' + pct + '%"></i></div>' +
          '<b>' + pct + '%</b>' +
          '</div>';
      }).join('') +
      '</div>' +
      '</article>';
  }

  function speedBucketsHtml(rows, payload) {
    rows = Array.isArray(rows) ? rows : [];
    if (!rows.length) {
      return '<article class="pkpi__speed-bucket-card"><h4>No speed rows yet</h4><p>The automatic audit has not returned page timing data.</p></article>';
    }
    var stats = speedStats(rows);
    var ttfbValues = speedValues(rows, 'ttfb');
    var totalValues = speedValues(rows, 'total');
    var sizeValues = speedValues(rows, 'size');
    var cards = [
      speedBucketCard(
        'Server response (TTFB)',
        'p75 ' + formatDurationMs(stats.ttfbP75) + ', p95 ' + formatDurationMs(stats.ttfbP95) + '. Target: under 800ms.',
        ttfbValues,
        800,
        1800
      ),
      speedBucketCard(
        'HTML download time',
        'p75 ' + formatDurationMs(stats.totalP75) + ', p95 ' + formatDurationMs(stats.totalP95) + '. Target: under 1.5s.',
        totalValues,
        1500,
        3000
      ),
      speedBucketCard(
        'HTML document weight',
        'p75 ' + formatBytesValue(stats.sizeP75) + ', average ' + formatBytesValue(stats.sizeAvg) + '. Target: under 300 KB.',
        sizeValues,
        300000,
        600000
      ),
      '<article class="pkpi__speed-bucket-card">' +
        '<h4>Audit coverage</h4>' +
        '<p>' + escapeHtml(formatInteger(stats.count) + ' URLs checked' + (stats.statusCount ? ', ' + formatRatio(stats.okCount, stats.statusCount) + ' returned OK.' : '.')) + '</p>' +
        '<div class="pkpi__speed-bucket-facts">' +
          '<span><strong>' + escapeHtml(formatInteger(stats.slowTtfbCount)) + '</strong> over 800ms TTFB</span>' +
          '<span><strong>' + escapeHtml(formatInteger(stats.badTotalCount)) + '</strong> over 3s download</span>' +
          '<span><strong>' + escapeHtml(formatInteger(stats.veryHeavyCount)) + '</strong> over 600 KB HTML</span>' +
          '<span><strong>' + escapeHtml(payload && payload.limited ? 'HTTP' : 'Vitals') + '</strong> audit mode</span>' +
        '</div>' +
      '</article>'
    ];
    return cards.join('');
  }

  function psiAuditListHtml(items, emptyTitle, emptyDetail) {
    if (!Array.isArray(items) || !items.length) {
      return '<article class="pkpi__psi-audit-row pkpi__psi-audit-row--watch">' +
        '<div><h4>' + escapeHtml(emptyTitle || 'No audit rows yet') + '</h4>' +
        '<p>' + escapeHtml(emptyDetail || 'The automatic audit has not returned enough data.') + '</p></div>' +
        '<strong>Pending</strong>' +
        '</article>';
    }
    return items.map(function (item) {
      return '<article class="pkpi__psi-audit-row pkpi__psi-audit-row--' + (item.tone || 'watch') + '">' +
        '<div><h4>' + escapeHtml(item.title || '') + '</h4><p>' + escapeHtml(item.detail || '') + '</p></div>' +
        '<strong>' + escapeHtml(item.impact || item.value || '') + '</strong>' +
        '</article>';
    }).join('');
  }

  function speedFieldHtml(rows, payload) {
    rows = Array.isArray(rows) ? rows : [];
    if (!rows.length) {
      return '<article class="pkpi__psi-field-card pkpi__psi-field-card--watch"><span>Field data</span><strong>Pending</strong><p>Waiting for the automatic speed audit.</p></article>';
    }
    var stats = speedStats(rows);
    var okTone = ratioTone(stats.okCount, stats.statusCount || stats.count);
    var ttfbTone = speedToneForMetric('ttfb', stats.ttfbP75);
    var totalTone = speedToneForMetric('total', stats.totalP75);
    var sizeTone = speedToneForMetric('size', stats.sizeP75);
    var limited = payload && payload.limited;
    var fieldValue = limited ? 'No CrUX' : 'Available';
    var fieldDetail = limited
      ? 'Browser-level Core Web Vitals are not available, so this page is using crawl timing like TTFB, transfer time, and HTML size.'
      : 'Lighthouse/PageSpeed metrics are available for the selected audit rows.';
    return [
      '<article class="pkpi__psi-field-card pkpi__psi-field-card--' + (limited ? 'watch' : 'good') + '"><span>Core Web Vitals</span><strong>' + escapeHtml(fieldValue) + '</strong><p>' + escapeHtml(fieldDetail) + '</p></article>',
      '<article class="pkpi__psi-field-card pkpi__psi-field-card--' + okTone + '"><span>Crawl coverage</span><strong>' + escapeHtml(formatInteger(stats.count)) + '</strong><p>' + escapeHtml((stats.statusCount ? formatRatio(stats.okCount, stats.statusCount) + ' URLs returned OK.' : 'URLs included in the timing sample.')) + '</p></article>',
      '<article class="pkpi__psi-field-card pkpi__psi-field-card--' + ttfbTone + '"><span>p75 TTFB</span><strong>' + escapeHtml(formatDurationMs(stats.ttfbP75)) + '</strong><p>Good is under 800ms.</p></article>',
      '<article class="pkpi__psi-field-card pkpi__psi-field-card--' + totalTone + '"><span>p75 download</span><strong>' + escapeHtml(formatDurationMs(stats.totalP75)) + '</strong><p>Good is under 1.5s for HTML transfer.</p></article>',
      '<article class="pkpi__psi-field-card pkpi__psi-field-card--' + sizeTone + '"><span>p75 HTML</span><strong>' + escapeHtml(formatBytesValue(stats.sizeP75)) + '</strong><p>Good is under 300 KB before assets.</p></article>'
    ].join('');
  }

  function speedDiagnosticsHtml(rows, payload) {
    rows = Array.isArray(rows) ? rows : [];
    if (!rows.length) return psiAuditListHtml([], 'Diagnostics are running', 'Waiting for page timing rows.');
    var stats = speedStats(rows);
    var slowestTtfb = worstSpeedRow(rows, 'ttfb');
    var slowestTotal = worstSpeedRow(rows, 'total');
    var heaviest = worstSpeedRow(rows, 'size');
    var items = [
      {
        tone: speedToneForMetric('ttfb', stats.ttfbP75),
        title: 'Avoid long server response times',
        detail: 'p75 TTFB is ' + formatDurationMs(stats.ttfbP75) + '. Slowest page: ' + speedRowLabel(slowestTtfb) + ' at ' + speedMetricDisplay(slowestTtfb, 'ttfb') + '.',
        impact: formatInteger(stats.slowTtfbCount) + ' slow'
      },
      {
        tone: speedToneForMetric('size', stats.sizeP75),
        title: 'Keep the initial document lightweight',
        detail: 'p75 HTML is ' + formatBytesValue(stats.sizeP75) + '. Heaviest page: ' + speedRowLabel(heaviest) + ' at ' + speedMetricDisplay(heaviest, 'size') + '.',
        impact: formatInteger(stats.heavyCount) + ' heavy'
      },
      {
        tone: speedToneForMetric('total', stats.totalP75),
        title: 'Reduce document transfer time',
        detail: 'p75 HTML download is ' + formatDurationMs(stats.totalP75) + '. Slowest transfer: ' + speedRowLabel(slowestTotal) + ' at ' + speedMetricDisplay(slowestTotal, 'total') + '.',
        impact: formatInteger(stats.slowTotalCount) + ' slow'
      },
      {
        tone: payload && payload.limited ? 'watch' : 'good',
        title: 'Core Web Vitals collection',
        detail: payload && payload.limited ? (payload.warning || 'The audit is using HTTP timing fallback, so LCP, CLS, TBT, and INP are not populated.') : 'Lighthouse/PageSpeed metrics are present for the current audit.',
        impact: payload && payload.limited ? 'Fallback' : 'Ready'
      }
    ];
    if (stats.statusCount) {
      items.push({
        tone: ratioTone(stats.okCount, stats.statusCount),
        title: 'Avoid failed page responses',
        detail: formatRatio(stats.okCount, stats.statusCount) + ' checked URLs returned OK.',
        impact: formatRatio(stats.okCount, stats.statusCount)
      });
    }
    return psiAuditListHtml(items, 'No diagnostics yet', 'The automatic audit has not returned enough data.');
  }

  function speedRowStatus(row) {
    if (!row) return '-';
    if (row.statusCode != null && String(row.statusCode).trim() !== '') return String(row.statusCode);
    if (row.ok === true) return 'OK';
    if (row.ok === false) return 'ERR';
    return '-';
  }

  function speedRowListHtml(rows, key, limit) {
    var sorted = speedRowsForMetric(rows, key).slice(0, limit || 8);
    if (!sorted.length) return emptyMsg('No rows with ' + key + ' timing yet.');
    return '<div class="pkpi__speed-row-list">' + sorted.map(function (row, index) {
      var tone = speedToneForMetric(key, metricNumberFromRow(row, key));
      var meta = [];
      if (key !== 'ttfb' && metricNumberFromRow(row, 'ttfb')) meta.push('TTFB ' + speedMetricDisplay(row, 'ttfb'));
      if (key !== 'total' && metricNumberFromRow(row, 'total')) meta.push('Download ' + speedMetricDisplay(row, 'total'));
      if (key !== 'size' && metricNumberFromRow(row, 'size')) meta.push('HTML ' + speedMetricDisplay(row, 'size'));
      if (speedRowStatus(row) !== '-') meta.push('Status ' + speedRowStatus(row));
      return '<div class="pkpi__speed-row">' +
        '<div class="pkpi__speed-row-path"><b>' + escapeHtml(index + 1) + '</b><span title="' + escapeHtml(speedRowLabel(row)) + '">' + escapeHtml(speedRowLabel(row)) + '</span></div>' +
        '<div class="pkpi__speed-row-meta">' + escapeHtml(meta.join(' - ') || 'Timing row') + '</div>' +
        '<strong class="pkpi__speed-row-value pkpi__site-page-metric--' + tone + '">' + escapeHtml(speedMetricDisplay(row, key)) + '</strong>' +
        '</div>';
    }).join('') + '</div>';
  }

  function speedTemplateName(row) {
    var path = row && row.path ? String(row.path) : '';
    if (!path && row && row.url) {
      try { path = new URL(row.url).pathname; } catch (e) { path = String(row.url || ''); }
    }
    if (path === '/' || !path) return 'Homepage';
    if (/^\/products\//.test(path)) return 'Product pages';
    if (/^\/collections\//.test(path)) return 'Collection pages';
    if (/^\/blogs?\//.test(path)) return 'Blog pages';
    if (/^\/pages\//.test(path)) return 'Content pages';
    if (/^\/a\//.test(path)) return 'App/proxy pages';
    if (/^\/cart/.test(path)) return 'Cart';
    if (/^\/search/.test(path)) return 'Search';
    return 'Other public pages';
  }

  function speedTemplatesHtml(rows) {
    rows = Array.isArray(rows) ? rows : [];
    if (!rows.length) return emptyMsg('No page templates were checked.');
    var groups = {};
    rows.forEach(function (row) {
      var key = speedTemplateName(row);
      if (!groups[key]) groups[key] = [];
      groups[key].push(row);
    });
    var items = Object.keys(groups).map(function (name) {
      var groupRows = groups[name];
      var stats = speedStats(groupRows);
      var worst = worstSpeedRow(groupRows, 'ttfb');
      return {
        name: name,
        count: groupRows.length,
        stats: stats,
        worst: worst,
        score: stats.ttfbP75 + (stats.veryHeavyCount * 100) + (stats.badTotalCount * 100)
      };
    }).sort(function (a, b) { return b.score - a.score; });
    return '<div class="pkpi__speed-template-list">' + items.map(function (item) {
      var tone = speedToneForMetric('ttfb', item.stats.ttfbP75);
      return '<div class="pkpi__speed-template-row">' +
        '<div><strong>' + escapeHtml(item.name) + '</strong><span>' + escapeHtml(formatInteger(item.count) + ' URLs - p75 TTFB ' + formatDurationMs(item.stats.ttfbP75) + ', avg HTML ' + formatBytesValue(item.stats.sizeAvg)) + '</span></div>' +
        '<span class="pkpi__site-page-metric pkpi__site-page-metric--' + tone + '">' + escapeHtml(item.worst ? speedMetricDisplay(item.worst, 'ttfb') : '-') + '</span>' +
        '</div>';
    }).join('') + '</div>';
  }

  function speedFixesHtml(rows, payload) {
    rows = Array.isArray(rows) ? rows : [];
    if (!rows.length) return psiAuditListHtml([], 'No timing data yet', 'The automatic audit has not returned enough page metrics to rank fixes.');
    var stats = speedStats(rows);
    var fixes = [];
    var slowestTtfb = worstSpeedRow(rows, 'ttfb');
    var slowestTotal = worstSpeedRow(rows, 'total');
    var heaviest = worstSpeedRow(rows, 'size');
    if (payload && (payload.warning || payload.limited)) {
      fixes.push({
        tone: 'watch',
        title: 'Restore full Lighthouse/Core Web Vitals coverage',
        detail: (payload.warning || 'The audit is currently using HTTP timing fallback.') + ' The fallback is useful for page response and weight, but LCP, CLS, TBT, and INP need browser-level data.',
        impact: 'Vitals'
      });
    }
    if (stats.slowTtfbCount > 0) {
      fixes.push({
        tone: stats.badTtfbCount ? 'bad' : 'watch',
        title: 'Reduce server response time on slow templates',
        detail: formatInteger(stats.slowTtfbCount) + ' of ' + formatInteger(stats.count) + ' checked URLs are over 800ms TTFB. Slowest: ' + speedRowLabel(slowestTtfb) + ' at ' + speedMetricDisplay(slowestTtfb, 'ttfb') + '. Check Liquid complexity, app blocks, redirects, and Shopify app proxy work on those templates.',
        impact: formatDurationMs(Math.max(0, metricNumberFromRow(slowestTtfb, 'ttfb') - 800))
      });
    }
    if (stats.heavyCount > 0) {
      fixes.push({
        tone: stats.veryHeavyCount ? 'bad' : 'watch',
        title: 'Cut heavy HTML before image and script work',
        detail: formatInteger(stats.heavyCount) + ' URLs are over 300 KB of raw HTML. Heaviest: ' + speedRowLabel(heaviest) + ' at ' + speedMetricDisplay(heaviest, 'size') + '. Remove duplicate app snippets, unused sections, inline JSON, and template content that ships before the first render.',
        impact: formatBytesValue(Math.max(0, metricNumberFromRow(heaviest, 'size') - 300000))
      });
    }
    if (stats.slowTotalCount > 0) {
      fixes.push({
        tone: stats.badTotalCount ? 'bad' : 'watch',
        title: 'Prioritize pages with slow HTML transfer',
        detail: formatInteger(stats.slowTotalCount) + ' URLs took over 1.5s to download HTML. Slowest download: ' + speedRowLabel(slowestTotal) + ' at ' + speedMetricDisplay(slowestTotal, 'total') + '. Re-test after reducing document size and app-generated markup.',
        impact: formatDurationMs(Math.max(0, metricNumberFromRow(slowestTotal, 'total') - 1500))
      });
    }
    if (!fixes.length) {
      fixes.push({
        tone: 'good',
        title: 'Basic timing looks healthy',
        detail: 'The checked URLs are within the current TTFB, transfer, and HTML weight thresholds. Keep watching Core Web Vitals once browser-level results are available.',
        impact: 'Passed'
      });
    }
    return psiAuditListHtml(fixes.slice(0, 5), 'No opportunities yet', 'The automatic audit has not returned enough data.');
  }

  function speedPageTableHtml(rows) {
    rows = Array.isArray(rows) ? rows.slice() : [];
    if (!rows.length) return emptyMsg('No URL timing rows were returned.');
    rows.sort(function (a, b) {
      return metricNumberFromRow(b, 'ttfb') - metricNumberFromRow(a, 'ttfb');
    });
    return '<div class="pkpi__speed-table-scroll"><table class="pkpi__speed-table">' +
      '<thead><tr><th>URL</th><th>Status</th><th>TTFB</th><th>Download</th><th>HTML weight</th></tr></thead>' +
      '<tbody>' + rows.map(function (row) {
        var statusTone = speedStatusOk(row) ? 'good' : 'bad';
        return '<tr>' +
          '<td><span title="' + escapeHtml(speedRowLabel(row)) + '">' + escapeHtml(speedRowLabel(row)) + '</span></td>' +
          '<td><b class="pkpi__site-page-status--' + statusTone + '">' + escapeHtml(speedRowStatus(row)) + '</b></td>' +
          '<td><b class="pkpi__site-page-metric--' + speedToneForMetric('ttfb', metricNumberFromRow(row, 'ttfb')) + '">' + escapeHtml(speedMetricDisplay(row, 'ttfb')) + '</b></td>' +
          '<td><b class="pkpi__site-page-metric--' + speedToneForMetric('total', metricNumberFromRow(row, 'total')) + '">' + escapeHtml(speedMetricDisplay(row, 'total')) + '</b></td>' +
          '<td><b class="pkpi__site-page-metric--' + speedToneForMetric('size', metricNumberFromRow(row, 'size')) + '">' + escapeHtml(speedMetricDisplay(row, 'size')) + '</b></td>' +
          '</tr>';
      }).join('') + '</tbody></table></div>';
  }

  function renderSpeedDetails(root, rows, payload) {
    rows = Array.isArray(rows) ? rows.filter(Boolean) : [];
    var field = root.querySelector('[data-kpi-speed-field]');
    if (field) field.innerHTML = speedFieldHtml(rows, payload || {});
    var buckets = root.querySelector('[data-kpi-speed-buckets]');
    if (buckets) buckets.innerHTML = speedBucketsHtml(rows, payload);
    var diagnostics = root.querySelector('[data-kpi-speed-diagnostics]');
    if (diagnostics) diagnostics.innerHTML = speedDiagnosticsHtml(rows, payload || {});
    var slowest = root.querySelector('[data-kpi-speed-slowest]');
    if (slowest) slowest.innerHTML = speedRowListHtml(rows, 'ttfb', 8);
    var heavy = root.querySelector('[data-kpi-speed-heavy]');
    if (heavy) heavy.innerHTML = speedRowListHtml(rows, 'size', 8);
    var templates = root.querySelector('[data-kpi-speed-templates]');
    if (templates) templates.innerHTML = speedTemplatesHtml(rows);
    var fixes = root.querySelector('[data-kpi-speed-fixes]');
    if (fixes) fixes.innerHTML = speedFixesHtml(rows, payload || {});
    var table = root.querySelector('[data-kpi-speed-page-table]');
    if (table) table.innerHTML = speedPageTableHtml(rows);
  }

  function speedLimitedVitalsHtml(rows) {
    var ttfb = worstSpeedRow(rows, 'ttfb');
    var total = worstSpeedRow(rows, 'total');
    var size = worstSpeedRow(rows, 'size');
    var okRows = rows.filter(function (row) {
      var code = parseMetricNumber(row && row.statusCode);
      return code >= 200 && code < 400;
    });
    return [
      {
        label: 'TTFB',
        value: metricDisplay(ttfb, 'ttfb', '-'),
        detail: speedRowLabel(ttfb) + ' server response timing.',
        tone: speedToneForMetric('ttfb', metricNumberFromRow(ttfb, 'ttfb')),
        target: 'Target < 800ms'
      },
      {
        label: 'Download',
        value: metricDisplay(total, 'total', '-'),
        detail: speedRowLabel(total) + ' HTML transfer time.',
        tone: speedToneForMetric('total', metricNumberFromRow(total, 'total')),
        target: 'Target < 1.5s'
      },
      {
        label: 'HTML weight',
        value: metricDisplay(size, 'size', '-'),
        detail: speedRowLabel(size) + ' raw document size.',
        tone: speedToneForMetric('size', metricNumberFromRow(size, 'size')),
        target: 'Target < 300 KB'
      },
      {
        label: 'Status',
        value: formatRatio(okRows.length, rows.length),
        detail: 'HTTP response codes for audited URLs.',
        tone: ratioTone(okRows.length, rows.length),
        target: 'Target all OK'
      }
    ].map(function (card) {
      return psiMetricHtml(card);
    }).join('');
  }

  function limitedSpeedConcerns(rows, warning) {
    var ttfb = worstSpeedRow(rows, 'ttfb');
    var total = worstSpeedRow(rows, 'total');
    var size = worstSpeedRow(rows, 'size');
    return [
      {
        rank: '1',
        tone: 'watch',
        title: 'Core Web Vitals need Lighthouse',
        detail: warning || 'The automatic endpoint fell back to basic HTTP timing.'
      },
      {
        rank: '2',
        tone: speedToneForMetric('ttfb', metricNumberFromRow(ttfb, 'ttfb')),
        title: 'Server response timing',
        detail: speedRowLabel(ttfb) + ' returned first bytes in ' + metricDisplay(ttfb, 'ttfb') + '.'
      },
      {
        rank: '3',
        tone: metricNumberFromRow(total, 'total') <= 2000 ? 'good' : 'watch',
        title: 'HTML transfer timing',
        detail: speedRowLabel(total) + ' downloaded in ' + metricDisplay(total, 'total') + '.'
      },
      {
        rank: '4',
        tone: metricNumberFromRow(size, 'size') <= 300000 ? 'good' : 'watch',
        title: 'Document weight',
        detail: speedRowLabel(size) + ' HTML weighs ' + metricDisplay(size, 'size') + '.'
      }
    ];
  }

  function formatRatio(good, total) {
    good = parseMetricNumber(good);
    total = parseMetricNumber(total);
    if (!total) return '-';
    return formatInteger(good) + '/' + formatInteger(total);
  }

  function ratioTone(good, total) {
    good = parseMetricNumber(good);
    total = parseMetricNumber(total);
    if (!total) return 'watch';
    var pct = good / total;
    if (pct >= 0.98) return 'good';
    if (pct >= 0.9) return 'watch';
    return 'bad';
  }

  function statusTone(ok, warning) {
    if (ok) return warning ? 'watch' : 'good';
    return 'bad';
  }

  function renderSiteAuditLoading(root) {
    var label = speedDeviceLabel(currentSpeedDevice(root));
    setSpeedText(root, '[data-kpi-site-pages-checked]', 'Running');
    setSpeedText(root, '[data-kpi-site-pages-status]', 'Checking ' + label.toLowerCase() + ' tracked page responses.');
    setSpeedText(root, '[data-kpi-site-commerce-status]', 'Checking');
    setSpeedText(root, '[data-kpi-site-commerce-detail]', 'Looking for ' + label.toLowerCase() + ' product forms, cart links, and checkout signals.');
    setSpeedText(root, '[data-kpi-site-action-status]', 'Checking');
    setSpeedText(root, '[data-kpi-site-action-detail]', 'Scanning links, buttons, forms, and submit inputs.');
    var summary = root.querySelector('[data-kpi-site-audit-summary]');
    if (summary) {
      summary.innerHTML = [
        '<article class="pkpi__site-card--watch"><span>Pages checked</span><strong>...</strong><p>Loading tracked URLs.</p></article>',
        '<article class="pkpi__site-card--watch"><span>Working pages</span><strong>...</strong><p>Waiting for HTTP responses.</p></article>',
        '<article class="pkpi__site-card--watch"><span>Button coverage</span><strong>...</strong><p>Scanning links, buttons, forms, and submit inputs.</p></article>',
        '<article class="pkpi__site-card--watch"><span>Add to cart</span><strong>...</strong><p>Checking product page cart form signals.</p></article>'
      ].join('');
    }
    var pages = root.querySelector('[data-kpi-site-pages]');
    if (pages) pages.innerHTML = emptyMsg('Checking tracked pages...');
    var actions = root.querySelector('[data-kpi-site-actions]');
    if (actions) actions.innerHTML = emptyMsg('Checking buttons, cart, and checkout signals...');
  }

  function renderSiteAuditError(root, message) {
    setSpeedText(root, '[data-kpi-site-pages-checked]', 'Unavailable');
    setSpeedText(root, '[data-kpi-site-pages-status]', message || 'Site audit did not return data.');
    setSpeedText(root, '[data-kpi-site-commerce-status]', 'Unavailable');
    setSpeedText(root, '[data-kpi-site-commerce-detail]', 'Could not check product/cart signals.');
    setSpeedText(root, '[data-kpi-site-action-status]', 'Unavailable');
    setSpeedText(root, '[data-kpi-site-action-detail]', 'Could not check action coverage.');
    var pages = root.querySelector('[data-kpi-site-pages]');
    if (pages) pages.innerHTML = emptyMsg(message || 'No page audit data.');
    var actions = root.querySelector('[data-kpi-site-actions]');
    if (actions) actions.innerHTML = emptyMsg('No action audit data.');
  }

  function siteAuditVitalsHtml(audit, timingRows) {
    audit = audit || {};
    var slowest = audit.slowestPages && audit.slowestPages[0];
    if (!slowest && Array.isArray(timingRows)) slowest = worstSpeedRow(timingRows, 'ttfb');
    var productTotal = parseMetricNumber(audit.productCount);
    var productOk = parseMetricNumber(audit.productAddToCartCount);
    var buttonTotal = parseMetricNumber(audit.checkedCount);
    var buttonOk = parseMetricNumber(audit.pagesWithButtonsCount);
    var okTone = ratioTone(audit.okCount, audit.checkedCount);
    var buttonTone = ratioTone(buttonOk, buttonTotal);
    var cartTone = productTotal ? ratioTone(productOk, productTotal) : 'watch';
    var slowTone = speedToneForMetric('ttfb', metricNumberFromRow(slowest, 'ttfb'));
    var cards = [
      {
        tone: okTone,
        label: 'Pages OK',
        value: formatRatio(audit.okCount, audit.checkedCount),
        detail: formatInteger(audit.brokenCount || 0) + ' problem responses from tracked pages.'
      },
      {
        tone: slowTone,
        label: 'Slowest TTFB',
        value: slowest ? metricDisplay(slowest, 'ttfb', '-') : '-',
        detail: slowest ? (slowest.path || speedRowLabel(slowest)) : 'No timing row yet.'
      },
      {
        tone: buttonTone,
        label: 'Buttons/links',
        value: formatRatio(buttonOk, buttonTotal),
        detail: 'Pages with buttons, links, forms, or submit controls.'
      },
      {
        tone: cartTone,
        label: 'Add to cart',
        value: productTotal ? formatRatio(productOk, productTotal) : '-',
        detail: 'Product pages with product-form or /cart/add signals.'
      }
    ];
    return cards.map(function (card) {
      return '<article class="pkpi__speed-vital--' + card.tone + '">' +
        '<span>' + escapeHtml(card.label) + '</span>' +
        '<strong>' + escapeHtml(card.value) + '</strong>' +
        '<p>' + escapeHtml(card.detail) + '</p>' +
        '</article>';
    }).join('');
  }

  function siteAuditSummaryHtml(audit) {
    audit = audit || {};
    var productTotal = parseMetricNumber(audit.productCount);
    var productOk = parseMetricNumber(audit.productAddToCartCount);
    var cards = [
      {
        tone: 'neutral',
        label: 'Pages checked',
        value: formatInteger(audit.checkedCount || 0),
        detail: 'Tracked URLs from the current KPI feed.'
      },
      {
        tone: ratioTone(audit.okCount, audit.checkedCount),
        label: 'Working pages',
        value: formatRatio(audit.okCount, audit.checkedCount),
        detail: formatInteger(audit.brokenCount || 0) + ' broken/error responses.'
      },
      {
        tone: ratioTone(audit.pagesWithButtonsCount, audit.checkedCount),
        label: 'Button coverage',
        value: formatRatio(audit.pagesWithButtonsCount, audit.checkedCount),
        detail: 'Pages with links, buttons, forms, or submit controls.'
      },
      {
        tone: productTotal ? ratioTone(productOk, productTotal) : 'watch',
        label: 'Add to cart',
        value: productTotal ? formatRatio(productOk, productTotal) : '-',
        detail: productTotal ? 'Product pages with add-to-cart/product-form signals.' : 'No product pages checked.'
      }
    ];
    return cards.map(function (card) {
      var tone = card.tone === 'neutral' ? '' : ' pkpi__site-card--' + card.tone;
      return '<article class="' + tone.trim() + '">' +
        '<span>' + escapeHtml(card.label) + '</span>' +
        '<strong>' + escapeHtml(card.value) + '</strong>' +
        '<p>' + escapeHtml(card.detail) + '</p>' +
        '</article>';
    }).join('');
  }

  function sitePageTone(page) {
    if (!page || page.ok !== true) return 'bad';
    if (parseMetricNumber(page.ttfbMs) > 1200 || (page.isProduct && !page.hasAddToCart)) return 'watch';
    return 'good';
  }

  function sitePagePriority(page) {
    var tone = sitePageTone(page);
    if (tone === 'bad') return 0;
    if (page && page.isProduct && !page.hasAddToCart) return 1;
    if (page && !page.hasButtons) return 2;
    if (tone === 'watch') return 3;
    return 4;
  }

  function syncSiteEvidenceHeights(root) {
    var pagesRoot = root.querySelector('[data-kpi-site-pages]');
    var actionsRoot = root.querySelector('[data-kpi-site-actions]');
    var list = pagesRoot && pagesRoot.querySelector('.pkpi__site-page-list');
    if (!pagesRoot || !actionsRoot || !list) return;

    list.style.removeProperty('height');
    list.style.removeProperty('max-height');

    if (window.matchMedia && window.matchMedia('(max-width: 1100px)').matches) return;

    var actionHeight = actionsRoot.getBoundingClientRect().height;
    if (!actionHeight) return;

    var note = pagesRoot.querySelector('.pkpi__evidence-note');
    var noteHeight = note ? note.getBoundingClientRect().height : 0;
    var noteMargin = 0;
    if (note && window.getComputedStyle) {
      noteMargin = parseFloat(window.getComputedStyle(note).marginBottom) || 0;
    }
    var target = Math.round(actionHeight - noteHeight - noteMargin);
    if (!Number.isFinite(target) || target < 360) return;

    list.style.height = target + 'px';
    list.style.maxHeight = target + 'px';
  }

  function scheduleSiteEvidenceHeightSync(root) {
    if (!root || root.__pkpiSiteEvidenceHeightFrame) return;
    root.__pkpiSiteEvidenceHeightFrame = (window.requestAnimationFrame || window.setTimeout)(function () {
      root.__pkpiSiteEvidenceHeightFrame = null;
      syncSiteEvidenceHeights(root);
    });
  }

  function renderSitePages(root, audit) {
    var target = root.querySelector('[data-kpi-site-pages]');
    if (!target) return;
    var pages = Array.isArray(audit && audit.pageChecks) ? audit.pageChecks.slice() : [];
    if (!pages.length) {
      target.innerHTML = emptyMsg('No tracked pages were checked.');
      return;
    }
    pages.sort(function (a, b) {
      var priority = sitePagePriority(a) - sitePagePriority(b);
      if (priority) return priority;
      return parseMetricNumber(b.ttfbMs) - parseMetricNumber(a.ttfbMs);
    });
    var problemCount = pages.filter(function (page) { return sitePagePriority(page) < 4; }).length;
    var intro = problemCount
      ? '<div class="pkpi__evidence-note pkpi__evidence-note--bad"><strong>' + escapeHtml(formatInteger(problemCount)) + ' page checks need attention</strong><span>Problem rows are first. Each row shows URL, response status, TTFB, and action/cart signal coverage.</span></div>'
      : '<div class="pkpi__evidence-note pkpi__evidence-note--good"><strong>All checked pages returned OK</strong><span>Full evidence list is still shown below, sorted by slowest response first.</span></div>';
    target.innerHTML = '<div class="pkpi__site-page-list">' + pages.map(function (page) {
      var tone = sitePageTone(page);
      var notes = [];
      if (page.buttonCount != null || page.linkCount != null) notes.push(formatInteger((page.buttonCount || 0) + (page.linkCount || 0)) + ' clickable signals');
      if (page.isProduct) notes.push(page.hasAddToCart ? 'add-to-cart signal' : 'missing add-to-cart signal');
      if (page.error) notes.push(page.error);
      var status = page.statusCode || (page.ok ? 'OK' : 'ERR');
      return '<div class="pkpi__site-page-row">' +
        '<div><span class="pkpi__site-page-path" title="' + escapeHtml(page.path || page.url || '') + '">' + escapeHtml(page.path || page.url || '') + '</span>' +
        '<span class="pkpi__site-page-note">' + escapeHtml(notes.join(' - ') || 'Page responded.') + '</span></div>' +
        '<span class="pkpi__site-page-status pkpi__site-page-status--' + tone + '">' + escapeHtml(status) + '</span>' +
        '<span class="pkpi__site-page-metric pkpi__site-page-metric--' + speedToneForMetric('ttfb', parseMetricNumber(page.ttfbMs)) + '">' + escapeHtml(page.ttfb || '-') + '</span>' +
        '<span class="pkpi__site-page-metric pkpi__site-page-metric--' + (page.hasButtons ? 'good' : 'watch') + '">' + escapeHtml(page.hasButtons ? 'actions' : 'no action') + '</span>' +
        '</div>';
    }).join('') + '</div>';
    target.innerHTML = intro + target.innerHTML;
  }

  function renderSiteActions(root, audit) {
    var target = root.querySelector('[data-kpi-site-actions]');
    if (!target) return;
    var actions = Array.isArray(audit && audit.actionChecks) ? audit.actionChecks.slice() : [];
    if (!actions.length) {
      target.innerHTML = emptyMsg('No action checks returned.');
      return;
    }
    actions.sort(function (a, b) {
      var order = { bad: 0, watch: 1, good: 2, neutral: 3 };
      var at = a.tone || statusTone(a.ok, a.warning);
      var bt = b.tone || statusTone(b.ok, b.warning);
      return (order[at] == null ? 3 : order[at]) - (order[bt] == null ? 3 : order[bt]);
    });
    var failing = actions.filter(function (action) {
      var tone = action.tone || statusTone(action.ok, action.warning);
      return tone === 'bad' || tone === 'watch';
    }).length;
    var intro = failing
      ? '<div class="pkpi__evidence-note pkpi__evidence-note--bad"><strong>' + escapeHtml(formatInteger(failing)) + ' action checks need attention</strong><span>Missing or weak commerce/action signals are listed first.</span></div>'
      : '<div class="pkpi__evidence-note pkpi__evidence-note--good"><strong>All critical action checks passed</strong><span>Cart, checkout, page response, and button coverage evidence is listed below.</span></div>';
    target.innerHTML = '<div class="pkpi__site-actions">' + actions.map(function (action) {
      var tone = action.tone || statusTone(action.ok, action.warning);
      return '<article class="pkpi__site-action-row pkpi__site-action-row--' + tone + '">' +
        '<span>' + escapeHtml(action.label || '') + '</span>' +
        '<strong>' + escapeHtml(action.value || '') + '</strong>' +
        '<p>' + escapeHtml(action.detail || '') + '</p>' +
        '</article>';
    }).join('') + '</div>';
    target.innerHTML = intro + target.innerHTML;
  }

  function setSiteMiniTone(root, selector, tone) {
    var target = root.querySelector(selector);
    var card = target && target.closest('.pkpi__speed-mini');
    if (!card) return;
    card.classList.remove('pkpi__speed-mini--bad', 'pkpi__speed-mini--watch', 'pkpi__speed-mini--good');
    card.classList.add('pkpi__speed-mini--' + (tone || 'watch'));
  }

  function renderSiteAudit(root, audit, timingRows) {
    if (!audit || typeof audit !== 'object') {
      renderSiteAuditError(root, 'No site audit data returned.');
      return;
    }
    var label = speedDeviceLabel(audit.device || currentSpeedDevice(root));
    var productTone = audit.productCount ? ratioTone(audit.productAddToCartCount, audit.productCount) : 'watch';
    var actionTone = ratioTone(audit.pagesWithButtonsCount, audit.checkedCount);
    var pageTone = ratioTone(audit.okCount, audit.checkedCount);
    setSiteMiniTone(root, '[data-kpi-site-pages-checked]', pageTone);
    setSiteMiniTone(root, '[data-kpi-site-commerce-status]', productTone);
    setSiteMiniTone(root, '[data-kpi-site-action-status]', actionTone);
    setSpeedText(root, '[data-kpi-site-pages-checked]', formatInteger(audit.checkedCount || 0));
    setSpeedText(root, '[data-kpi-site-pages-status]', label + ' check: ' + formatRatio(audit.okCount, audit.checkedCount) + ' pages returned OK.');
    setSpeedText(root, '[data-kpi-site-commerce-status]', audit.productCount ? formatRatio(audit.productAddToCartCount, audit.productCount) : 'No products');
    setSpeedText(root, '[data-kpi-site-commerce-detail]', audit.productCount ? label + ' product pages with add-to-cart/product-form signals.' : 'No product pages were included in this audit.');
    setSpeedText(root, '[data-kpi-site-action-status]', formatRatio(audit.pagesWithButtonsCount, audit.checkedCount));
    setSpeedText(root, '[data-kpi-site-action-detail]', label + ' pages with links, buttons, forms, or submit controls.');
    var summary = root.querySelector('[data-kpi-site-audit-summary]');
    if (summary) summary.innerHTML = siteAuditSummaryHtml(audit);
    renderSitePages(root, audit);
    renderSiteActions(root, audit);
    scheduleSiteEvidenceHeightSync(root);
  }

  function siteAuditConcerns(audit, warning) {
    audit = audit || {};
    var concerns = [];
    if (parseMetricNumber(audit.brokenCount) > 0) {
      var broken = audit.problemPages && audit.problemPages[0];
      concerns.push({
        rank: '1',
        tone: 'bad',
        title: 'Broken or error pages',
        detail: formatInteger(audit.brokenCount) + ' tracked pages did not return OK. First issue: ' + (broken && (broken.path + ' returned ' + broken.statusCode) || 'see page status list') + '.'
      });
    }
    if (parseMetricNumber(audit.productMissingAddToCartCount) > 0) {
      var product = audit.productMissingAddToCartPages && audit.productMissingAddToCartPages[0];
      concerns.push({
        rank: String(concerns.length + 1),
        tone: 'bad',
        title: 'Product add-to-cart signal missing',
        detail: formatInteger(audit.productMissingAddToCartCount) + ' product pages did not expose an add-to-cart/product-form signal. First: ' + (product && product.path || 'see action list') + '.'
      });
    }
    if (parseMetricNumber(audit.pagesWithoutButtonsCount) > 0) {
      concerns.push({
        rank: String(concerns.length + 1),
        tone: 'watch',
        title: 'Pages with no clickable signal',
        detail: formatInteger(audit.pagesWithoutButtonsCount) + ' checked pages had no links, buttons, forms, or submit controls in the loaded HTML.'
      });
    }
    if (parseMetricNumber(audit.checkoutSignalPagesCount) === 0) {
      concerns.push({
        rank: String(concerns.length + 1),
        tone: 'watch',
        title: 'Checkout signal not found',
        detail: 'The audit did not find checkout links/text in loaded HTML. JS-only checkout flows still need browser click testing.'
      });
    }
    var slowest = audit.slowestPages && audit.slowestPages[0];
    if (slowest) {
      concerns.push({
        rank: String(concerns.length + 1),
        tone: speedToneForMetric('ttfb', parseMetricNumber(slowest.ttfbMs)),
        title: 'Slowest server response',
        detail: (slowest.path || slowest.url || 'Slowest page') + ' returned first bytes in ' + (slowest.ttfb || '-') + '.'
      });
    }
    if (warning) {
      concerns.push({
        rank: String(concerns.length + 1),
        tone: 'watch',
        title: 'Core Web Vitals fallback',
        detail: warning
      });
    }
    return concerns;
  }

  function renderSiteConcerns(root, audit, warning) {
    var target = root.querySelector('[data-kpi-site-concerns]');
    if (!target) return;
    target.innerHTML = speedConcernsHtml(siteAuditConcerns(audit, warning));
  }

  function setSpeedHtml(root, selector, html) {
    var target = root.querySelector(selector);
    if (target) target.innerHTML = html;
  }

  function renderSpeedDetailPlaceholders(root, message) {
    var text = message || 'Checking speed timing data...';
    setSpeedHtml(root, '[data-kpi-speed-field]', '<article class="pkpi__psi-field-card pkpi__psi-field-card--watch"><span>Field data</span><strong>Pending</strong><p>' + escapeHtml(text) + '</p></article>');
    setSpeedHtml(root, '[data-kpi-speed-buckets]', '<article class="pkpi__speed-bucket-card"><h4>Audit running</h4><p>' + escapeHtml(text) + '</p></article>');
    setSpeedHtml(root, '[data-kpi-speed-slowest]', emptyMsg(text));
    setSpeedHtml(root, '[data-kpi-speed-heavy]', emptyMsg(text));
    setSpeedHtml(root, '[data-kpi-speed-templates]', emptyMsg(text));
    setSpeedHtml(root, '[data-kpi-speed-fixes]', psiAuditListHtml([], 'Audit running', text));
    setSpeedHtml(root, '[data-kpi-speed-diagnostics]', psiAuditListHtml([], 'Diagnostics are running', text));
    setSpeedHtml(root, '[data-kpi-speed-page-table]', emptyMsg(text));
  }

  function renderSpeedLoading(root) {
    root.__pkpiPerformancePayload = null;
    root.__pkpiPerformanceError = '';
    var device = currentSpeedDevice(root);
    var label = speedDeviceLabel(device);
    setSpeedText(root, '[data-kpi-speed-url]', '');
    setSpeedText(root, '[data-kpi-speed-score]', '...');
    setSpeedText(root, '[data-kpi-speed-state]', 'Running ' + label.toLowerCase() + ' audit');
    setSpeedText(root, '[data-kpi-speed-heading]', 'Checking ' + label.toLowerCase() + ' speed timing.');
    setSpeedText(root, '[data-kpi-speed-summary]', 'The local preview server is checking ' + label.toLowerCase() + ' response timing, HTML transfer, page weight, and Core Web Vitals if available.');
    setSpeedText(root, '[data-kpi-speed-command]', 'GET /api/performance-kpis?device=' + device);
    setSpeedText(root, '[data-kpi-speed-updated]', 'Auto audit in progress');
    setSpeedText(root, '[data-kpi-speed-overview-score]', 'Running');
    setSpeedText(root, '[data-kpi-speed-overview-status]', label + ' speed timing starts automatically on page load.');
    setSpeedText(root, '[data-kpi-speed-field-state]', 'Checking');
    setSpeedText(root, '[data-kpi-speed-threshold-label]', label + '-style thresholds');
    setSpeedScoreRing(root, 0);
    renderSiteAuditLoading(root);
    renderSpeedDetailPlaceholders(root, 'Checking ' + label.toLowerCase() + ' tracked URL response timing, transfer time, and HTML weight.');
    renderCurrentHealth(root);
    refreshActivatedView(root, root.__pkpiView);
  }

  function renderSpeedError(root, message) {
    root.__pkpiPerformancePayload = null;
    root.__pkpiPerformanceError = message || 'Speed audit failed';
    setSpeedText(root, '[data-kpi-speed-score]', '!');
    setSpeedText(root, '[data-kpi-speed-state]', 'Audit unavailable');
    setSpeedText(root, '[data-kpi-speed-heading]', 'Automatic speed audit could not run.');
    setSpeedText(root, '[data-kpi-speed-summary]', message || 'The local endpoint returned no result.');
    setSpeedText(root, '[data-kpi-speed-command]', 'Install Node/npm or wait for PageSpeed quota, then reload.');
    setSpeedText(root, '[data-kpi-speed-updated]', 'Auto audit failed');
    setSpeedText(root, '[data-kpi-speed-overview-score]', 'Unavailable');
    setSpeedText(root, '[data-kpi-speed-overview-status]', message || 'The audit endpoint returned an error.');
    setSpeedText(root, '[data-kpi-speed-field-state]', 'Unavailable');
    setSpeedScoreRing(root, 0);
    renderSiteAuditError(root, message);
    var concerns = root.querySelector('[data-kpi-speed-concerns]');
    if (concerns) concerns.innerHTML = speedConcernsHtml([]);
    renderSpeedDetailPlaceholders(root, message || 'Speed audit did not return data.');
    renderCurrentHealth(root);
    refreshActivatedView(root, root.__pkpiView);
  }

  function renderSpeedResults(root, payload) {
    root.__pkpiPerformancePayload = payload || {};
    root.__pkpiPerformanceError = '';
    var payloadDevice = normalizeSpeedDevice(payload && (payload.device || payload.preset));
    root.__pkpiSpeedDevice = payloadDevice;
    renderDeviceToggles(root);
    var payloadLabel = speedDeviceLabel(payloadDevice);
    var sourceUrl = payload && Array.isArray(payload.urls) && payload.urls[0]
      ? payload.urls[0]
      : payload && payload.siteAudit && payload.siteAudit.baseUrl || '';
    setSpeedText(root, '[data-kpi-speed-url]', sourceUrl);
    renderCurrentHealth(root);
    refreshActivatedView(root, root.__pkpiView);
    var rows = Array.isArray(payload && payload.summary) ? payload.summary : [];
    var auditRows = payload && payload.siteAudit && Array.isArray(payload.siteAudit.pageChecks) ? payload.siteAudit.pageChecks : [];
    if (!rows.length && auditRows.length) rows = auditRows;
    var score = payload && payload.averageScore != null ? parseMetricNumber(payload.averageScore) : averageSpeedScore(rows);
    if (!rows.length) {
      renderSpeedError(root, payload && payload.error || 'No speed rows were returned.');
      return;
    }
    if (payload && payload.limited) {
      renderSiteAudit(root, payload.siteAudit, rows);
      var limitedRows = auditRows.length ? auditRows : rows;
      var limitedScore = score == null ? fallbackSpeedScore(limitedRows) : score;
      setSpeedText(root, '[data-kpi-speed-score]', limitedScore == null ? '-' : String(limitedScore));
      setSpeedScoreRing(root, limitedScore);
      setSpeedText(root, '[data-kpi-speed-state]', payloadLabel + ' HTTP timing fallback');
      setSpeedText(root, '[data-kpi-speed-heading]', payloadLabel + ' HTTP timing fallback is ready.');
      setSpeedText(root, '[data-kpi-speed-summary]', 'Showing measured response timing, HTML transfer, and page weight. This is not a Lighthouse/PageSpeed lab score. ' + (payload.warning || ''));
      setSpeedText(root, '[data-kpi-speed-command]', payload.source || 'Automatic HTTP timing fallback');
      setSpeedText(root, '[data-kpi-speed-updated]', payload.updatedAt ? 'Updated ' + payload.updatedAt : 'Auto timing complete');
      setSpeedText(root, '[data-kpi-speed-overview-score]', formatInteger(limitedRows.length) + ' URLs');
      setSpeedText(root, '[data-kpi-speed-overview-status]', 'Loaded ' + payloadLabel.toLowerCase() + ' automatic HTTP timing fallback.');
      setSpeedText(root, '[data-kpi-speed-threshold-label]', payloadLabel + ' HTTP timing thresholds');
      var limitedTotal = worstSpeedRow(limitedRows, 'total');
      var limitedStats = speedStats(limitedRows);
      setSpeedText(root, '[data-kpi-speed-field-state]', 'Fallback');
      setSpeedText(root, '[data-kpi-speed-overview-risk]', 'p75 TTFB ' + formatDurationMs(limitedStats.ttfbP75));
      setSpeedText(root, '[data-kpi-speed-overview-risk-detail]', 'p75 download ' + formatDurationMs(limitedStats.totalP75) + ' - p75 HTML ' + formatBytesValue(limitedStats.sizeP75));
      if (limitedTotal) setSpeedText(root, '[data-kpi-speed-overview-status]', speedRowLabel(limitedTotal) + ' downloaded in ' + metricDisplay(limitedTotal, 'total') + '.');
      var limitedVitals = root.querySelector('[data-kpi-speed-vitals]');
      if (limitedVitals) limitedVitals.innerHTML = speedLimitedVitalsHtml(limitedRows);
      var limitedConcerns = root.querySelector('[data-kpi-speed-concerns]');
      if (limitedConcerns) limitedConcerns.innerHTML = speedConcernsHtml(payload.concerns || limitedSpeedConcerns(limitedRows, payload.warning));
      renderSpeedDetails(root, limitedRows, payload);
      renderSiteConcerns(root, payload.siteAudit, payload.warning);
      renderCurrentHealth(root);
      refreshActivatedView(root, root.__pkpiView);
      return;
    }
    renderSiteAudit(root, payload.siteAudit, rows);
    renderSiteConcerns(root, payload.siteAudit);
    var state = payload.status === 'cached' ? 'Cached result' : 'Latest result';
    var detailRows = auditRows.length ? auditRows : rows;
    var displayScore = score == null ? fallbackSpeedScore(detailRows) : score;
    setSpeedText(root, '[data-kpi-speed-score]', displayScore == null ? '-' : String(displayScore));
    setSpeedScoreRing(root, displayScore);
    setSpeedText(root, '[data-kpi-speed-state]', state + ' - ' + payloadLabel);
    setSpeedText(root, '[data-kpi-speed-heading]', speedIssueTitle(displayScore || 0, rows));
    setSpeedText(root, '[data-kpi-speed-summary]', speedIssueSummary(rows));
    setSpeedText(root, '[data-kpi-speed-command]', payload.source || 'Automatic Lighthouse audit');
    setSpeedText(root, '[data-kpi-speed-updated]', payload.updatedAt ? 'Updated ' + payload.updatedAt : 'Auto audit complete');
    setSpeedText(root, '[data-kpi-speed-overview-score]', 'Score ' + (displayScore == null ? '-' : String(displayScore)));
    setSpeedText(root, '[data-kpi-speed-overview-status]', (payload.status === 'cached' ? 'Loaded cached ' + payloadLabel.toLowerCase() + ' speed audit.' : payloadLabel + ' automatic speed audit complete.'));
    setSpeedText(root, '[data-kpi-speed-threshold-label]', payloadLabel + '-style thresholds');
    setSpeedText(root, '[data-kpi-speed-field-state]', payload.limited ? 'Fallback' : 'Available');

    var lcp = worstSpeedRow(rows, 'lcp');
    var tbt = worstSpeedRow(rows, 'tbt');
    if (lcp) setSpeedText(root, '[data-kpi-speed-overview-risk]', 'LCP ' + metricDisplay(lcp, 'lcp'));
    if (tbt) setSpeedText(root, '[data-kpi-speed-overview-risk-detail]', speedRowLabel(tbt) + ' has TBT ' + metricDisplay(tbt, 'tbt') + '.');

    var vitals = root.querySelector('[data-kpi-speed-vitals]');
    if (vitals) vitals.innerHTML = speedVitalsHtml(rows);
    var concerns = root.querySelector('[data-kpi-speed-concerns]');
    if (concerns) concerns.innerHTML = speedConcernsHtml(payload.concerns || deriveSpeedConcerns(rows, score));
    renderSpeedDetails(root, detailRows, payload);
    renderCurrentHealth(root);
    refreshActivatedView(root, root.__pkpiView);
  }

  function speedAuditUrl(root, force, rangeOverride, siteCheckOnly) {
    var source = normalizeLiveApiSource(root.getAttribute('data-kpi-speed-source'));
    if (!source) return '';
    var device = currentSpeedDevice(root);
    var range = rangeOverride || currentPerformanceRange(root);
    var sep = source.indexOf('?') === -1 ? '?' : '&';
    return source + sep +
      'force=' + (force ? '1' : '0') +
      '&device=' + encodeURIComponent(device) +
      '&range=' + encodeURIComponent(range) +
      (siteCheckOnly ? '&siteCheck=1' : '') +
      '&_t=' + Date.now();
  }

  function fetchSpeedPayload(root, force, rangeOverride, siteCheckOnly) {
    var url = speedAuditUrl(root, force, rangeOverride, siteCheckOnly);
    if (!url) return Promise.resolve(null);
    return fetchJson(url, { cache: 'no-store' }, 60000, 'Speed audit')
      .catch(function (error) {
        var device = currentSpeedDevice(root);
        var snapshotAttr = device === 'mobile' ? 'data-kpi-speed-mobile-snapshot-source' : 'data-kpi-speed-snapshot-source';
        var snapshotSource = normalizeSnapshotSource(root.getAttribute(snapshotAttr));
        if (!snapshotSource) throw error;
        var sep = snapshotSource.indexOf('?') === -1 ? '?' : '&';
        var fallbackUrl = snapshotSource + sep +
          'device=' + encodeURIComponent(device) +
          '&range=' + encodeURIComponent(rangeOverride || currentPerformanceRange(root)) +
          '&_t=' + Date.now();
        return fetchJson(fallbackUrl, { cache: 'no-store' }, 20000, 'Generated speed snapshot')
          .catch(function () {
            throw error;
          });
      });
  }

  function runSpeedAudit(root, force) {
    var source = root.getAttribute('data-kpi-speed-source');
    if (!source) return;
    var requestId = (root.__pkpiSpeedRequestId || 0) + 1;
    root.__pkpiSpeedRequestId = requestId;
    renderDeviceToggles(root);
    renderSpeedLoading(root);
    fetchSpeedPayload(root, force)
      .then(function (payload) {
        if (requestId !== root.__pkpiSpeedRequestId) return;
        renderSpeedResults(root, payload);
      })
      .catch(function (error) {
        if (requestId !== root.__pkpiSpeedRequestId) return;
        renderSpeedError(root, error && error.message ? error.message : 'Speed audit failed');
      });
  }

  function bindSpeedAudit(root) {
    if (!root.getAttribute('data-kpi-speed-source')) return;
    renderDeviceToggles(root);
    var refresh = root.querySelector('[data-kpi-speed-refresh]');
    if (refresh && !refresh.dataset.kpiSpeedBound) {
      refresh.dataset.kpiSpeedBound = '1';
      refresh.addEventListener('click', function () {
        if (refresh.disabled) return;
        runSpeedAudit(root, true);
      });
    }
    if (refresh) {
      refresh.disabled = false;
      refresh.classList.remove('pkpi__speed-refresh--disabled');
      refresh.textContent = 'Analyze again';
      refresh.title = '';
    }
    if (!root.__pkpiSpeedStarted && !root.__pkpiSuppressAutoSpeedStart) {
      root.__pkpiSpeedStarted = true;
      runSpeedAudit(root, false);
    }
  }

  // ── Main render ────────────────────────────────────────────────────────────

  function renderDashboard(root, data, rangeId) {
    if (!data || typeof data !== 'object') return;
    root.classList.remove('pkpi--loading');
    var loading = root.querySelector('[data-kpi-loading]');
    if (loading) loading.hidden = true;
    root.__pkpiData = data;
    var view = getSelectedData(data, rangeId);
    root.__pkpiRangeId = view.id;
    root.__pkpiInitialRange = view.id;
    if (data.customRange) root.__pkpiPendingCustomRange = data.customRange;
    saveDashboardState(root);
    root.__pkpiRangeUnavailable = !!view.rangeUnavailable;
    if (root.__pkpiPagesRange !== view.id) {
      root.__pkpiPagesRange = view.id;
      root.__pkpiPageNumber = 1;
    }

    if (!Array.isArray(view.topPages) || !view.topPages.length) {
      view.topPages = deriveTopPages(view.pages);
    }
    if (!Array.isArray(view.worstPages) || !view.worstPages.length) {
      view.worstPages = deriveWorstPages(view.pages);
    }

    renderPeriodSlot(root, data, view.id);
    renderControls(root, data, view.id);
    renderMeta(root, view);
    renderHealthCommandCenter(root, view);
    renderSummary(root, buildSummaryItems(view));
    renderOverviewChart(root, view.charts);
    renderCharts(root, '[data-kpi-traffic-charts]', view.charts);
    renderPriorities(root, view.priorities);
    renderTopPages(root, view.topPages);
    renderWorstPages(root, view.worstPages);
    renderFunnel(root, view.funnel);
    renderPages(root, view.pages);
    renderBreakdown(root, '[data-kpi-devices]', view.devices);
    renderBreakdown(root, '[data-kpi-sources]', view.sources);
    renderTrafficBreakdowns(root, view);
    renderEvents(root, view.events);
    renderGlossary(root, view.definitions || data.definitions);
    bindSpeedAudit(root);
    applyView(root);
  }

  function ensureLoadingPanel(root) {
    var existing = root.querySelector('[data-kpi-loading]');
    if (existing) return existing;
    var panel = document.createElement('div');
    panel.className = 'pkpi__loading-view';
    panel.setAttribute('data-kpi-loading', '');
    var hero = root.querySelector('.pkpi__hero');
    if (hero && hero.parentNode) {
      hero.parentNode.insertBefore(panel, hero.nextSibling);
    } else {
      root.appendChild(panel);
    }
    return panel;
  }

  function renderDashboardLoading(root, message) {
    message = message || 'Loading live KPI values...';
    root.classList.add('pkpi--loading');
    renderControls(root, root.__pkpiData || minimalDashboardData(root), root.__pkpiRangeId || root.__pkpiInitialRange || '1d');
    renderPeriodSlot(root, root.__pkpiData || minimalDashboardData(root), root.__pkpiRangeId || root.__pkpiInitialRange || '1d');
    var status = root.querySelector('[data-kpi-feed-status]');
    if (status) status.textContent = message;
    var updated = root.querySelector('[data-kpi-updated]');
    if (updated) updated.textContent = '';
    var range = root.querySelector('[data-kpi-range]');
    if (range) range.textContent = '';
    Array.prototype.forEach.call(root.querySelectorAll('[data-kpi-view]'), function (el) {
      el.hidden = true;
    });
    var panel = ensureLoadingPanel(root);
    panel.hidden = false;
    panel.innerHTML =
      '<div class="pkpi__loading-inner">' +
        '<div class="pkpi__loading-copy">' +
          '<span class="pkpi__chart-eyebrow">Live dashboard</span>' +
          '<h2>Loading current metrics</h2>' +
          '<p>' + escapeHtml(message) + '</p>' +
        '</div>' +
        '<div class="pkpi__loading-steps" aria-label="Loading steps">' +
          '<span><i></i> Shopify sessions and orders</span>' +
          '<span><i></i> Site checks</span>' +
          '<span><i></i> Saved view and range</span>' +
        '</div>' +
      '</div>';
  }

  function renderDashboardError(root, error, source) {
    var message = error && error.message ? error.message : 'The live KPI endpoint did not return real data.';
    root.classList.add('pkpi--loading');
    renderControls(root, root.__pkpiData || minimalDashboardData(root), root.__pkpiRangeId || root.__pkpiInitialRange || '1d');
    renderPeriodSlot(root, root.__pkpiData || minimalDashboardData(root), root.__pkpiRangeId || root.__pkpiInitialRange || '1d');
    var status = root.querySelector('[data-kpi-feed-status]');
    if (status) {
      status.textContent = 'Live feed unavailable';
      status.className = 'pkpi__hero-pill pkpi__hero-pill--status pkpi__hero-pill--error';
    }
    var updated = root.querySelector('[data-kpi-updated]');
    if (updated) updated.textContent = '';
    var range = root.querySelector('[data-kpi-range]');
    if (range) range.textContent = '';
    Array.prototype.forEach.call(root.querySelectorAll('[data-kpi-view]'), function (el) {
      el.hidden = true;
    });
    var panel = ensureLoadingPanel(root);
    panel.hidden = false;
    panel.classList.add('pkpi__loading-view--error');
    panel.innerHTML =
      '<div class="pkpi__loading-inner">' +
        '<div class="pkpi__loading-copy">' +
          '<span class="pkpi__chart-eyebrow">Live Shopify data</span>' +
          '<h2>No live values returned</h2>' +
          '<p>' + escapeHtml(message) + '</p>' +
          '<p>No generated Shopify snapshot was available either.</p>' +
        '</div>' +
        '<div class="pkpi__loading-steps" aria-label="Live data source">' +
          '<span><i></i> Source: ' + escapeHtml(source || 'Live KPI API') + '</span>' +
          '<span><i></i> Shopify Admin data must come through the private backend</span>' +
          '<span><i></i> Browser-side hardcoded KPI values are disabled</span>' +
        '</div>' +
      '</div>';
  }

  function snapshotUrlForRange(source, rangeId) {
    if (!source) return '';
    var sep = source.indexOf('?') === -1 ? '?' : '&';
    return source + sep + 'range=' + encodeURIComponent(rangeId || '1d') + '&_t=' + Date.now();
  }

  function fetchSnapshotData(snapshotSource, rangeId) {
    var url = snapshotUrlForRange(snapshotSource, rangeId);
    if (!url) return Promise.reject(new Error('No generated KPI snapshot is available yet.'));
    return fetchJson(url, { cache: 'no-store' }, 20000, 'Generated KPI snapshot');
  }

  function renderSnapshotFallback(root, data, requestedRange) {
    var renderRange = requestedRange === 'all'
      ? (root.__pkpiRangeId && root.__pkpiRangeId !== 'single' ? root.__pkpiRangeId : (data.defaultRange || '1d'))
      : requestedRange;
    renderDashboard(root, data, renderRange || data.defaultRange || '1d');
    root.__pkpiLiveLoaded = false;
    setCheckingStatus(root, 'Showing latest generated snapshot; live refresh unavailable on this device.');
    return data;
  }

  // ── Bootstrap ──────────────────────────────────────────────────────────────

  dashboards.forEach(function (root) {
    var savedState = readSavedState(root);
    root.__pkpiView = savedState.view || 'overview';
    root.__pkpiInitialRange = savedState.range || '1d';
    root.__pkpiRangeId = root.__pkpiInitialRange;
    if (savedState.customRange) root.__pkpiPendingCustomRange = savedState.customRange;

    var source = root.getAttribute('data-kpi-source');
    source = normalizeLiveApiSource(source);
    root.setAttribute('data-kpi-source', source || '');
    var snapshotSource = normalizeSnapshotSource(root.getAttribute('data-kpi-snapshot-source'));
    root.setAttribute('data-kpi-snapshot-source', snapshotSource || '');
    var speedSnapshotSource = normalizeSnapshotSource(root.getAttribute('data-kpi-speed-snapshot-source'));
    root.setAttribute('data-kpi-speed-snapshot-source', speedSnapshotSource || '');
    var speedMobileSnapshotSource = normalizeSnapshotSource(root.getAttribute('data-kpi-speed-mobile-snapshot-source'));
    root.setAttribute('data-kpi-speed-mobile-snapshot-source', speedMobileSnapshotSource || '');
    var speedSource = normalizeLiveApiSource(root.getAttribute('data-kpi-speed-source'));
    if (speedSource) root.setAttribute('data-kpi-speed-source', speedSource);
    if (!source) {
      renderDashboardError(root, new Error('No live KPI API URL is configured.'), '');
      return;
    }

    function fetchAndRender(rangeId, force, options) {
      options = options || {};
      var requestedRange = rangeId || root.__pkpiRangeId || (root.__pkpiData && root.__pkpiData.defaultRange) || '1d';
      var quiet = !!options.quiet;
      if (!quiet && (force !== false || !root.__pkpiData)) {
        renderDashboardLoading(root, requestedRange === 'all' ? 'Loading live Shopify and KPI data...' : 'Loading ' + rangeControlLabel(requestedRange) + ' values...');
      }
      var sep = source.indexOf('?') === -1 ? '?' : '&';
      var url = source + sep +
        'range=' + encodeURIComponent(requestedRange) +
        '&force=' + (force === false ? '0' : '1') +
        '&shopifyFresh=1' +
        '&_t=' + Date.now();
      var speedRange = requestedRange;
      if (requestedRange === 'all') {
        var liveRange = root.__pkpiLiveLoaded && root.__pkpiRangeId && root.__pkpiRangeId !== 'single'
          ? root.__pkpiRangeId
          : '1d';
        url += '&shopifyRange=' + encodeURIComponent(liveRange);
        speedRange = liveRange;
      }
      var customRangeForRequest = requestedRange === 'custom'
        ? (root.__pkpiPendingCustomRange || root.__pkpiData && root.__pkpiData.customRange || null)
        : null;
      if (customRangeForRequest) {
        if (customRangeForRequest.from) url += '&from=' + encodeURIComponent(customRangeForRequest.from);
        if (customRangeForRequest.to) url += '&to=' + encodeURIComponent(customRangeForRequest.to);
      }
      root.__pkpiSpeedStarted = true;
      var speedPromise = fetchSpeedPayload(root, true, speedRange, true)
        .catch(function (error) {
          return { __pkpiError: error && error.message ? error.message : 'Speed audit failed' };
        });
      function applySpeedPayload(speedPayload) {
        if (speedPayload && !speedPayload.__pkpiError) {
          root.__pkpiPerformancePayload = speedPayload;
          root.__pkpiPerformanceError = '';
        } else if (speedPayload && speedPayload.__pkpiError) {
          root.__pkpiPerformancePayload = null;
          root.__pkpiPerformanceError = speedPayload.__pkpiError;
        }
        if (speedPayload && speedPayload.__pkpiError) {
          renderSpeedError(root, speedPayload.__pkpiError);
        } else if (speedPayload) {
          renderSpeedResults(root, speedPayload);
        }
      }
      var s = root.querySelector('[data-kpi-feed-status]');
      if (s) s.textContent = quiet ? 'Showing saved values; checking for updates...' : 'Checking live data...';
      return fetchJson(url, { credentials: 'same-origin', cache: 'no-store' }, 60000, 'Live KPI data')
        .then(function (data) {
          if (requestedRange === 'custom' && customRangeForRequest) {
            data.customRange = customRangeForRequest;
            data.customRangeLabel = (customRangeForRequest.from && customRangeForRequest.to)
              ? 'Custom: ' + customRangeForRequest.from + ' – ' + customRangeForRequest.to
              : 'Custom period';
          }
          if (requestedRange !== 'all') {
            data = mergeRangeResponse(root.__pkpiData, data, requestedRange);
          }
          var renderRange = requestedRange === 'all'
            ? (root.__pkpiLiveLoaded && root.__pkpiRangeId && root.__pkpiRangeId !== 'single' ? root.__pkpiRangeId : (data.defaultRange || '1d'))
            : requestedRange;
          root.__pkpiSuppressAutoSpeedStart = true;
          try {
            renderDashboard(root, data, renderRange);
          } finally {
            root.__pkpiSuppressAutoSpeedStart = false;
          }
          root.__pkpiLiveLoaded = true;
          speedPromise.then(applySpeedPayload);
          return data;
        })
        .catch(function (error) {
          var fallbackRange = requestedRange === 'all'
            ? (root.__pkpiRangeId && root.__pkpiRangeId !== 'single' ? root.__pkpiRangeId : '1d')
            : requestedRange;
          return fetchSnapshotData(snapshotSource, fallbackRange)
            .then(function (data) {
              var rendered = renderSnapshotFallback(root, data, fallbackRange);
              speedPromise.then(applySpeedPayload);
              return rendered;
            })
            .catch(function () {
              throw error;
            });
        });
    }

    root.__pkpiFetchAndRender = fetchAndRender;

    var cached = null;
    var hasCachedRange = false;
    if (cached && cached.data) {
      root.__pkpiPendingCustomRange = savedState.customRange || cached.customRange || root.__pkpiPendingCustomRange;
      var cachedRange = root.__pkpiInitialRange || cached.range || '1d';
      hasCachedRange = !!findRange(cached.data, cachedRange);
      if (hasCachedRange) {
        if (cached.performance && (!cached.performance.range || cached.performance.range === cachedRange)) {
          root.__pkpiPerformancePayload = cached.performance;
          root.__pkpiPerformanceError = '';
          root.__pkpiSpeedStarted = true;
        }
        renderDashboard(root, cached.data, cachedRange);
        root.__pkpiLiveLoaded = true;
        setCheckingStatus(root, 'Showing saved values; checking for updates...');
      }
    }

    if (!hasCachedRange) {
      renderDashboardLoading(root, 'Loading live Shopify and KPI data...');
    }

    var firstRange = source.indexOf('127.0.0.1') !== -1 ? 'all' : (root.__pkpiInitialRange || '1d');
    fetchAndRender(firstRange, !hasCachedRange, { quiet: hasCachedRange }).catch(function (error) {
      renderDashboardError(root, error, source || snapshotSource);
    });

    setInterval(function () { fetchAndRender('all', false).catch(function () {}); }, 5 * 60 * 1000);

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      clearInteractionState();
      root.__pkpiView = 'overview';
      root.__pkpiInitialRange = '1d';
      root.__pkpiRangeId = '1d';
      if (typeof root.__pkpiFetchAndRender === 'function') {
        root.__pkpiFetchAndRender('1d', false, { quiet: true }).catch(function () {});
      } else if (root.__pkpiData) {
        renderDashboard(root, root.__pkpiData, '1d');
      }
    });
  });
})();
